import { AfterViewChecked, Component, ViewChildren, QueryList, ElementRef, OnInit, Renderer2, SimpleChanges, ViewChild, ChangeDetectorRef, AfterViewInit, HostListener} from '@angular/core';
import { ChatbotService } from '../../../services/chatbot-services/chatbot.service';
import { FormBuilder } from '@angular/forms';
import { environment } from "src/environments/environment";
import { PrivilegesService } from "../../../services/privileges-service/privileges.service"
import { SelectedModuleService } from '../../../services/selected-module-service/selected-module.service';
import { HttpResponse, HttpClient } from '@angular/common/http';
import moduleDetails from '../../../config/module_info.json';
import config from '../../../config/config.json';
import { Subscription } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { SharedService } from '../../../services/shared-service/shared.service';
import { ShowSourceService } from '../../../services/show-source/show-source.service';
import {ChatbotMetadataComponent} from '../../metadata/chatbot-metadata/chatbot-metadata.component'
import { AudioCopyComponent } from '../audio-copy/audio-copy.component';
import { VoiceInputComponent } from '../voice-input/voice-input.component';
import { LanguageChangeService } from 'src/services/language-change/language-change.service';
import { TranslateService } from '@ngx-translate/core';
import { TabSelectionEvent } from '../../models/chat-sessions.models';
import { ConfigurationService } from '../../../services/configuration/configuration.service';
import { ContenteditableModelDirective } from 'src/directives/contenteditable-textarea/contenteditable-model.directive';
import { DomainSwitchComponent } from '../domain-switch/domain-switch.component';
import { LoggerService } from 'src/services/logger-services/logger.service';
import { GlobalConfigService } from 'src/services/global-service/global-service.service';
import { FirstTimeLoginDetails, DataSetVdb, GetChatSessionsInfoEvent, PopupMessageEvent, ModuleInfo } from '../../models/chatbot.models';
import { FileUploadState, FileUploadTracker } from '../../models/file-upload.models';
import { FileUploadService } from '../../../services/doc-module-service/file-upload-service/file-upload.service';
import { uploadedFilesService } from '../../../services/doc-module-service/retrieval-service/retrieval-service';
import { AgentOrchestratorService } from '../../agents/services/agent-orchestrator/agent-orchestrator.service';
import { StreamingStateService } from '../../../shared/services/streaming-state/streaming-state.service';
import { MyFilesComponent } from '../my-files/my-files.component';
import { TokenService } from '../../../shared/services/token/token.service';
import { RegulationNextService } from '../../../services/regulation-next/regulation-next.service';
import { RetrievalModePreferenceService } from '../../../services/retrieval-mode-preference/retrieval-mode-preference.service';
import { extractRetrievalModeFromHistoryAnswer } from '../../../shared/utils/retrieval-mode.util';
@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})


export class ChatbotComponent implements OnInit, AfterViewChecked, AfterViewInit {
  @ViewChild(ContenteditableModelDirective) autoResizeDirective!: ContenteditableModelDirective;
  @ViewChild(ChatbotMetadataComponent) chatbotMetadataComponent!: ChatbotMetadataComponent;
  @ViewChild(VoiceInputComponent) voiceInputComponent!: VoiceInputComponent;
  @ViewChildren(AudioCopyComponent) audioCopies!: QueryList<AudioCopyComponent>;
  @ViewChild('domainSwitchComponent') domainSwitchComponent!: DomainSwitchComponent;
  @ViewChild('autoResizeTextarea') autoResizeTextarea?: ElementRef;
  textareaElement: HTMLElement | null = null;
  @ViewChild(MyFilesComponent) myFilesComponent?: MyFilesComponent;
  @ViewChild('myUploadedFilesRef') myUploadedFilesRef?: ElementRef<HTMLElement>;
  @ViewChild(MyFilesComponent, { read: ElementRef }) myFilesHostRef?: ElementRef<HTMLElement>;
  IsFirstTime: any = true;
  IsNewChat: any = true;
  isUserHaveAccess: any | undefined;
  txtChat: any;
  questiontxt: string = "";
  moduleName: string = "";
  userFName: any;
  data: any;
  answer: any;
  ChatQueriesList: any = [];
  ChatQueriesObj: any = {};
  SessionChatHistory: any = []
  chat: any;
  isStatic: boolean | undefined;
  loginId: any;
  chatSessionList: any = [];
  sessionIdClickArray: string[] = [];
  sessionIdArray: string[] = [];
  exportlist: string[] = [];
  DomainID: any;
  UserID: any;
  currentSessionId: any;
  isNewChatSession: boolean | undefined;
  defaultChat: boolean | undefined;
  typedText: any;
  showEdit: boolean | undefined;
  editIndex: any;
  updateQuestion: any;
  editText: any;
  followUpQuestions: any;
  followUpQuestionsShow: boolean | undefined;
  ChatbotAccessText: string = "";
  prompt: string = 'default';
  selectedItemIndex: number | null = null;
  loaderShow: boolean = false;
  popularQuestions: any;
  chatBotName: string = "";
  note: boolean = false;
  popularQuestionsShow: boolean | undefined;
  userDataPrivileges: any = [];
  Markets: any = [];
  configdata: any;
  isResponseScroll: boolean = true;
  isChecked: boolean = false;
  InsightViewURL: string = "/regulations?modulePath=/Insights/view-regulation?tab=true&insid=";
  allUserPrivileges: any = null;
  isDocChat: boolean = false;
  showSources = true;
  isLoading: boolean = false;
  favouriteDataset: string = ""
  currentLanguage: string;
  micActive: boolean = false;
  isDropdownOpen: boolean = false;
  dropdownWidth: number = 190;
  isMyUploadedFiles :boolean = false 
  isMyFilesLoading :boolean = false
  private textMeasureCanvas: HTMLCanvasElement | null = null;
  
  @HostListener('document:click', ['$event'])
  onDocumentClickCloseMyFiles(event: MouseEvent) {
    if (!this.isMyUploadedFiles) return;
    const container = (this.myFilesHostRef?.nativeElement || this.myUploadedFilesRef?.nativeElement);
    const target = event.target as Node | null;
    if (container && target && !container.contains(target)) {
      this.isMyUploadedFiles = false;
    }
  }
  
  @HostListener('document:mousedown', ['$event'])
  onDocumentMouseDownCloseMyFiles(event: MouseEvent) {
    if (!this.isMyUploadedFiles) return;
    const container = (this.myFilesHostRef?.nativeElement || this.myUploadedFilesRef?.nativeElement);
    const target = event.target as Node | null;
    if (container && target && !container.contains(target)) {
      this.isMyUploadedFiles = false;
    }
  }
  
  /**
   * Centralized file upload state - single source of truth
   * All file upload operations should reference this object
   */
  fileUploadState: FileUploadState = {
    uploadedFiles: [],
    activeUploads: new Map<string, FileUploadTracker>(),
    ui: {
      showFileCards: false,
      isDragOver: false,
      isPopupOpen: false,
      isProcessing: false
    },
    validation: {
      errors: [],
      showErrors: false
    },
    notification: {
      message: '',
      show: false
    },
    internal: {
      dragCounter: 0,
      dragLeaveTimeout: null
    }
  };

  allDomainNamesList: string[] = [];
  userSelectedDomains: string[] = [];
  isDomainManagementEnabled: boolean=false;

  DisLikeMessage: string = "";
  FeedbackOptions: any = [];
  AdditionalComments: string = "";
  
  // New chat confirmation popup state
  showNewChatConfirmationPopup: boolean = false;
  pendingNewChatSession: boolean = false;
  showAgentSwitchConfirmationPopup: boolean = false; // New popup for agent->chatbot switch
  showChatbotToAgentConfirmationPopup: boolean = false; // New popup for chatbot->agent switch
  pendingAgentId: string = ''; // Store the agent ID user wants to switch to
  previousAgentId: string = 'module'; // Store the previous agent ID before showing popup (for cancel)
  // Flag to track if we're in automatic session creation (to avoid popup)
  isAutoSessionCreation: boolean = false;
  
  // Save error confirmation popup state
  showSaveErrorConfirmationPopup: boolean = false;
  saveErrorMessage: string = "";
  
  // Share conversation popup state
  sharePopupData: any = null;
  linkCopied: boolean = false;
  FeedbackCBDict: any = {};
  DummyArray = [];
  jsonArray: string = "";
  IsLikeSelected: boolean = false;
  SubmitFeedback: boolean = false;
  ErrorMsg: boolean = false;
  count: number = 0;
  errorMsg: string = "";
  tenantID: any;
  streamResponseURL?: string;
  subModuleNames: any;
  xApiKey?: string;
  isOptionsEnable: boolean = true;
  vectorDbDatasets: DataSetVdb[] = [];
  Privileges: any;
  privilegesDataForAgents?: { cookiesArray: string[]; agentPrivileges: string[] };
  selectedVectorDbDataset: DataSetVdb | undefined;
  IsModuleAccessible = false;
  selected_module_name = "";
  IsResponseStreaming: boolean = false;
  showEngagingLoader: boolean = true; // When false, shows engaging loader; when true, shows dot loader (after jsonData.type == "streaming")
  IsLoader: boolean = false; // Track metadata fetching state for spinner in metadata header
  displayStopStreaming: boolean = false;
  ShowChatHistory: boolean = false;
  ConversationHistoryCount: number = 0;
  moduleThreadsCounts: { [moduleName: string]: number } = {}; // Store total count per module
  datasetApiTriggered: { [datasetName: string]: boolean } = {}; // Track which datasets have had their APIs triggered
  selectedTab: string = 'All'; // Track currently selected tab
  ShowRegulationMarketsWindow: boolean = false;
  RegulationId: string = "";
  RegulationMarkets: string = "";
  RegulationTitle: string = "";
  DeleteSuccessMessage: boolean = false;
  EditSuccessMessage: boolean = false;
  ShareSuccessMessage: boolean = false;
  ChatTitle: string = "";
  URFModuleId: number = 0;
  showHelp = false;
  IsCustomErrorMessageVisible: boolean = false;
  CustomErrorMessageText: string = "";
  isProcessing: boolean = false;
  showHelpMenu = false;
  DisplayPromptLibrary : boolean = false;
  DisplaySource : boolean = false;
  isListening : boolean = false;
  vectorDbDatasetList: any = [];
  isSourcePanelVisible: boolean = false;
  currentSourceData: any = null;
  isFilePreviewVisible: boolean = false;
  currentFilePreviewRequest: any = null;
  // Map to store file to documentId relationship
  private readonly fileToDocumentIdMap: Map<string, number> = new Map();
  firstTimeLoginDetails: FirstTimeLoginDetails = {
    introduction_wizard_enabled: false,
    wizard_completion_status: "incomplete",
    tour_functionality_enabled: false,
    tour_completion_status: "incomplete"
  };

  // Lazy loading properties
  selectedFilter: string = '30 Days';
  currentPage = 1;
  pageSize = 20;
  isLoadingsession = false;

  hasMoreData = true;
  
  // Dataset-specific pagination tracking
  datasetPagination: { [datasetName: string]: { currentPage: number; hasMoreData: boolean } } = {};
  
  // Dataset-specific loading state tracking
  datasetLoadingStates: { [datasetName: string]: boolean } = {};
  
  latestObject: any;
  showScrollToBottomArrow: boolean = false;

  private userHasScrolledUp: boolean = false;
  private lastScrollTop: number = 0;
  private readonly scrollDetectionThreshold: number = 5; // pixels
  private scrollTimeout: any = null;
  private isNearBottom: boolean = true;
  private chatContainer: HTMLElement | null = null;
  private isAutoScrolling: boolean = false;
  private scrollDebounceTimeout: any = null;
  private autoScrollTimeout: any = null;
  private lastAutoScrollTime: number = 0;

  // WebSocket subscriptions
  private streamingSubscription: Subscription | null = null;
  private newsStreamingSubscription: Subscription | null = null;
  
  // Public getter to check if there's an active streaming subscription
  get hasActiveStreamingSubscription(): boolean {
    return this.streamingSubscription !== null;
  }
  public newsData: any[] = []; // Store news and updates data
  public isNewsLoading: boolean = false;
  public newsLoadingStates: { [key: number]: boolean } = {}; // Track loading state per chat item
  public newsErrorStates: { [key: number]: string } = {}; // Track error state per chat item
  private pendingNewsWebSocketSave: { [key: number]: { pk_chat_history_id: any, fk_chatbotid: any, newsAndUpdates: any } } = {}; // Store pending news save when chat completes before news
  public responseLoadingStates: { [key: number]: boolean } = {}; // Track response loading state per chat item
  public newsAndUpdatesnodata: boolean = false;
  public websocketCompleteAndDataSaved: { [key: number]: boolean } = {}; // Track websocket completion and data saving per chat item
  public isNewsAndFeedsEnabled: boolean = false;
  public isFileUploadEnabled: boolean = false;
  public isRetrievalModeFeatureEnabled: boolean = false;
  private readonly ChatbotComponentError = (error: any)=>
    `[ChatbotComponent] - ${JSON.stringify(error)}`;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly chatbotService: ChatbotService,
    private readonly elementRef: ElementRef,
    private readonly privilegesService: PrivilegesService,
    private readonly sharedService: SelectedModuleService,
    private readonly renderer: Renderer2,
    private readonly showSourceService: ShowSourceService,
    private readonly sharedScrollService: SharedService,
    private readonly cdr: ChangeDetectorRef,
    private readonly languageService: LanguageChangeService,
    private readonly translate: TranslateService,
    private readonly configService: ConfigurationService,
    private readonly loggerService: LoggerService,
    private readonly fileUploadService: FileUploadService,
    private readonly http: HttpClient,
    private readonly agentOrchestrator: AgentOrchestratorService,
    private readonly streamingStateService: StreamingStateService,
    private readonly uploadedFilesService: uploadedFilesService,
    private readonly globalConfigService: GlobalConfigService,
    private readonly tokenService: TokenService,
    private readonly regulationNextService: RegulationNextService,
    private readonly retrievalModePreference: RetrievalModePreferenceService
  ) {
      this.currentLanguage = this.languageService.getCurrentLanguage();
    }

  async ngOnInit(): Promise<void> {
    this.sharedScrollService.currentResponseScroll.subscribe(isScroll => this.isResponseScroll = isScroll);
    this.IsFirstTime = false;
    this.IsNewChat = true;
    this.defaultChat = false;
    this.isUserHaveAccess = false;
    this.UserID = environment.LoginUserID;
    this.moduleName = environment.DomainName;
    this.userFName = environment.LoginUserName;
    this.userNameSimplify();
    this.tenantID = environment.TenantId;
    this.Privileges = environment.Privileges;
    this.IsLikeSelected = false;
    this.SubmitFeedback = false;
    this.ErrorMsg = false;
    this.VerifyUserAccessToChatBot(this.UserID, this.DomainID);

    this.getConfigData();

    // check if domain management is enabled or not
    this.isDomainManagementEnabled = await this.configService.isDomainManagementEnabled();
    // check if file upload is enabled or not
    this.isFileUploadEnabled = await this.configService.isFileUploadEnabled();
    this.isRetrievalModeFeatureEnabled = await this.configService.isRetrievalModeEnabled();
    // Initialize userSelectedDomains with MPR as default
    if (this.isDomainManagementEnabled) {
      this.userSelectedDomains = [];
      this.updateDomainsList();
    }
    
    // Subscribe to language changes to update dropdown width
    this.translate.onLangChange.subscribe(() => {
      this.resizeDropdownWidth();
    });

    this.DisLikeMessage = this.configdata.DisLikeMessage;
    this.FeedbackOptions = this.configdata.FeedbackOptions;

    environment.GlobalInfo["DomainID"] = this.DomainID;
    environment.GlobalInfo["URFModuleId"] = this.URFModuleId;

    this.GetDomainName();
    this.Listdatasets();
    this.loadInitialChatSessions()
    this.scrollToBottomSmooth();
    this.popularQuestionsShow = false;
    this.popularQuestions = [];
    this.chatBotName = environment.chatbotName;
    this.IsResponseStreaming = false;
    this.displayStopStreaming = false;
    this.IsLoader = false;
    this.isSourcePanelVisible = false;

    this.showSourceService.showSources$.subscribe(value => {
      this.showSources = value;
    });
    if (this.autoResizeDirective) {
      this.autoResizeDirective.resetHeight();
    }
    this.showSources = true;
    window.addEventListener('beforeunload', () => {
      if (this.audioCopies) {
        this.audioCopies.forEach(audioCopy => audioCopy.stopSpeaking());
      }
  });

  this.isNewsAndFeedsEnabled = await this.configService.isNewsAndFeedsEnabled();
  setTimeout(() => {
    this.initializeScrollDetector();
  }, 1000);
  }


  // Ensure to also handle unsubscribing when the component is destroyed to prevent memory leaks
  ngOnDestroy(): void {
    this.stopStreaming(); // Stop both streaming connections if they're still active
    if (this.audioCopies) {
      this.audioCopies.forEach(audioCopy => audioCopy.stopSpeaking());
    }
    if (this.chatContainer) {
      this.chatContainer.removeEventListener('scroll', this.handleScrollEvent.bind(this));
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    if (this.scrollDebounceTimeout) {
      clearTimeout(this.scrollDebounceTimeout);
    }
  }

  ngAfterViewInit(): void {
    this.resizeDropdownWidth();
     this.updateTextareaElement();
    // Set valid domains for highlighting after view is initialized
    if (this.autoResizeDirective) {
      const domainsForHighlighting = this.isDomainManagementEnabled && this.allDomainNamesList.length === 0 
        ? [] 
        : this.allDomainNamesList;
        
      if (domainsForHighlighting.length > 0) {
        setTimeout(() => {
          this.autoResizeDirective.setValidDomains(domainsForHighlighting);
          // Trigger highlighting if text already contains @
          if (this.txtChat && this.txtChat.includes('@')) {
            this.autoResizeDirective.triggerHighlighting();
          }
        }, 100);
      }
    }
  }

  private updateTextareaElement(): void {
    if (this.shouldShowAgentLanding) {
      this.textareaElement = null;
    } else {
      this.textareaElement = this.autoResizeTextarea?.nativeElement || null;
    }
    // Trigger change detection if needed
    if (this.cdr) {
      this.cdr.detectChanges();
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['moduleName']) {
      this.moduleName = environment.DomainName;
    }
    this.chatBotName = environment.chatbotName;
    this.showSourceService.setShowSources(this.showSources);
  }

  setFirstTimeLoginDetails(firstTimeLoginDetails: FirstTimeLoginDetails){
      if (firstTimeLoginDetails) {
        this.firstTimeLoginDetails = {
          introduction_wizard_enabled: firstTimeLoginDetails.introduction_wizard_enabled,
          wizard_completion_status: firstTimeLoginDetails.wizard_completion_status,
          tour_functionality_enabled: firstTimeLoginDetails.tour_functionality_enabled,
          tour_completion_status: firstTimeLoginDetails.tour_completion_status
        };
      }
    this.cdr.detectChanges(); // Trigger change detection
  }

  async setPrivilegesAndIds(privileges: any, DomainID: any, URFModuleId: any): Promise<void> {
    this.DomainID = DomainID;
    this.URFModuleId = URFModuleId;
    this.vectorDbDatasets = privileges.vectorDbDatasets;
    this.Privileges = privileges.cookiesArray;
    
    // Set privileges for Regulation Next INS_id redirect (gri.regulation.read)
    this.regulationNextService.setPrivileges(privileges.cookiesArray || []);
    
    // Store privileges data for passing to agent access control (avoid redundant API calls)
    this.privilegesDataForAgents = {
      cookiesArray: privileges.cookiesArray,
      agentPrivileges: privileges.agentPrivileges
    };
    
    // Set selected dataset based on favorite/localStorage AFTER vectorDbDatasets is populated
    await this.fetchPrivilegesAndDatasets();
    
    if(this.isDomainManagementEnabled){
      await this.updateDomainsList(); // Update domains based on current selected dataset
    }
    environment.GlobalInfo["vectorDbDatasets"] = privileges.vectorDbDatasets;
    environment.GlobalInfo["Privileges"] = privileges.cookiesArray;
    
    // Set valid domains for highlighting in the contenteditable directive
    if (this.autoResizeDirective) {
      const domainsForHighlighting = this.isDomainManagementEnabled && this.allDomainNamesList.length === 0 
        ? [] 
        : this.allDomainNamesList;
        
      if (domainsForHighlighting.length > 0) {
        this.autoResizeDirective.setValidDomains(domainsForHighlighting);
      }
    }
    this.cdr.detectChanges(); // Trigger change detection
  }


  async fetchPrivilegesAndDatasets(): Promise<void> {
    try {
      if (this.vectorDbDatasets && this.vectorDbDatasets.length > 0) {
        const localselectedVectorDbDataset = localStorage.getItem('selectedVectorDbDataset');

        // Parse and validate localStorage value
        let parsedSelectedDatset: DataSetVdb | null = null;
        try {
          parsedSelectedDatset = localselectedVectorDbDataset ? JSON.parse(localselectedVectorDbDataset) : null;
          // Check if parsed value is valid (not null, empty object, or empty string)
          if (parsedSelectedDatset && (
            typeof parsedSelectedDatset !== 'object' || 
            Object.keys(parsedSelectedDatset).length === 0 ||
            !parsedSelectedDatset.value ||
            parsedSelectedDatset.value === ""
          )) {
            parsedSelectedDatset = null;
          }
        } catch (e) {
          parsedSelectedDatset = null;
        }

        const index = parsedSelectedDatset ? this.vectorDbDatasets.findIndex(dataset => dataset.value === parsedSelectedDatset!.value) : -1;
        
        //setting favourite icon
        this.favouriteDataset = index !== -1 ? this.vectorDbDatasets[index].name : this.vectorDbDatasets.find(dataset => dataset.name.toLowerCase() === "regulations")?.name || this.vectorDbDatasets[0].name;
        
        // Update selectedDataset based on the existence of the module
        // Priority: localStorage value (if valid) > Regulations (if available) > First dataset
        this.selectedVectorDbDataset = index !== -1 ? this.vectorDbDatasets[index] : this.vectorDbDatasets.find(dataset => dataset.name.toLowerCase() === "regulations") || this.vectorDbDatasets[0];
        
        // Save to localStorage if this is the first time initialization (no previous valid selection found)
        if (index === -1 && this.selectedVectorDbDataset) {
          localStorage.setItem('selectedVectorDbDataset', JSON.stringify(this.selectedVectorDbDataset));
        }
        
        if(this.isDomainManagementEnabled){
          await this.updateDomainsList(); // Update domains when dataset is selected
        }
      }
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), "fetchVectorDbDatasets");
    }
  }

  /**
   * Ensures selectedVectorDbDataset is always valid (not undefined, null, {}, or "")
   * If invalid, sets it to "Regulations" if available, otherwise the first dataset
   * Also updates localStorage with the valid selection
   * @returns boolean - true if dataset was valid or successfully fixed, false if no datasets available
   */
  private ensureValidSelectedDataset(): boolean {
    try {
      // Check if vectorDbDatasets is available
      if (!this.vectorDbDatasets || this.vectorDbDatasets.length === 0) {
        this.loggerService.logError('[ChatbotComponent] No vectorDbDatasets available', 'ensureValidSelectedDataset');
        return false;
      }

      // Check if selectedVectorDbDataset is invalid (undefined, null, empty object, or has empty value)
      const isInvalid = !this.selectedVectorDbDataset || 
                        this.selectedVectorDbDataset === null || 
                        (typeof this.selectedVectorDbDataset === 'object' && Object.keys(this.selectedVectorDbDataset).length === 0) ||
                        !this.selectedVectorDbDataset.value ||
                        this.selectedVectorDbDataset.value === "";
      
      if (isInvalid) {
        // Set to Regulations if available, otherwise first dataset
        this.selectedVectorDbDataset = this.vectorDbDatasets.find(dataset => dataset.name.toLowerCase() === "regulations") || this.vectorDbDatasets[0];
        
        // Update localStorage and favourite dataset
        if (this.selectedVectorDbDataset) {
          localStorage.setItem('selectedVectorDbDataset', JSON.stringify(this.selectedVectorDbDataset));
          this.favouriteDataset = this.selectedVectorDbDataset.name;
          
          this.loggerService.logInfo(
            `[ChatbotComponent] selectedVectorDbDataset was invalid, reset to: ${this.selectedVectorDbDataset.name}`,
            'ensureValidSelectedDataset'
          );
          return true;
        }
      }
      
      return true;
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), "ensureValidSelectedDataset");
      return false;
    }
  }

  /**
   * Updates the allDomainNamesList based on the currently selected vector database dataset
   * Always calls the API to get fresh domain mapping for the selected module
   */
  async updateDomainsList(): Promise<void> {
    // Ensure selectedVectorDbDataset is valid before using it
    this.ensureValidSelectedDataset();
    
    if (!this.selectedVectorDbDataset?.name) {
      this.allDomainNamesList = [];
      return;
    }

    // Skip API call if domain management is not enabled
    if (!this.isDomainManagementEnabled) {
      return;
    }

    try {
      
      // Always call API to get fresh domain mapping for the selected module
      const allAccessibleUserDomains = await firstValueFrom(
        this.chatbotService.getAllUserDomainsAPI(
          environment.TenantId, 
          environment.LoginUserID, 
          this.selectedVectorDbDataset.name
        )
      );
      
      // Get the updated mapping
      const result = this.chatbotService.mapDomainsToModules(allAccessibleUserDomains);
      
      // Update the domains list for the current selected dataset
      this.allDomainNamesList = result.moduleDomainsMap[this.selectedVectorDbDataset.name] || [];
      
      
      // Update valid domains for highlighting if directive is available
      const domainsForHighlighting = this.allDomainNamesList.length === 0 ? [] : this.allDomainNamesList;
      if (this.autoResizeDirective && domainsForHighlighting.length > 0) {
        this.autoResizeDirective.setValidDomains(domainsForHighlighting);
      }
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), "updateDomainsList");
      
      // Check if the error is 401 (Unauthorized)
      if (error?.status === 401 || error?.status === 400) {
        const translatedMessage = this.translate.instant('DOMAIN_ACCESS_DENIED');
        
        this.IsCustomErrorMessageVisible = true;
        this.CustomErrorMessageText = translatedMessage;
        
        setTimeout(() => {
          this.IsCustomErrorMessageVisible = false;
          this.CustomErrorMessageText = "";
        }, 2000);
      }
      
      this.allDomainNamesList = [];
    }
  }

  Listdatasets() {
    for (let i = 0; i < this.vectorDbDatasets.length; i++) {
      this.vectorDbDatasetList.push(this.vectorDbDatasets[i].name);
    }
  }


  updateChatSessionList(updatedList: any[]): void {
    this.chatSessionList = [...updatedList]; // Update the chatSessionList with the new list
    this.ConversationHistoryCount = this.getConversationHistoryCount();
    this.cdr.detectChanges(); // Trigger change detection manually if needed
  }

  userNameSimplify() {
    // Add null/undefined check
    if (!this.userFName || typeof this.userFName !== 'string') {
        return;
    }

    // If userFName is an email, split it at '@' and take the first part
    if (this.userFName.includes("@")) {
        this.userFName = this.userFName.split("@")[0]; // Take only the part before '@'
    }

    // Split the name by '.' or '_' to handle cases like User.User name
    let names = this.userFName.split(/[._]/);

    // Ensure names only contain alphabets and make title case
    names = names.map((name: string) =>
        name.replace(/[^a-zA-Z]/g, "").replace(/\b\w/g, (l) => l.toUpperCase())
    );

    this.userFName = names[0]; // Use only the first name
}

  /* istanbul ignore next */
  getConfigData() {
    this.configdata = this.chatbotService.getConfigData();
    this.sharedService.currentSelectedValue.subscribe((value: any) => {
      // Ensure selectedVectorDbDataset is valid before using it
      this.ensureValidSelectedDataset();
      this.selected_module_name = value?.selectedVectorDbDataset?.value || this.selectedVectorDbDataset?.value;

      if (this.selected_module_name) {
        const moduleInfo = (moduleDetails as any)[this.selected_module_name];
        if (moduleInfo) {
          this.configdata.domain_specific = moduleInfo?.domain_specific || false;
          this.configdata.chatbotName = moduleInfo?.chatbotName || config?.chatbotName;
          this.configdata.IntroDetails = moduleInfo.IntroDetails?.replace("{{userFName}}", this.userFName) || config?.IntroDetails.replace("{{userFName}}", this.userFName);;
          this.configdata.isPopularQuestionStart = moduleInfo?.isPopularQuestionStart ?? config?.isPopularQuestionStart;
          this.configdata.isPopularQuestionModuleWise = moduleInfo?.isPopularQuestionModuleWise ?? false;
          this.configdata.MarketsPayloadRequired = moduleInfo?.MarketsPayloadRequired ?? false;
          const introContentKey = 'INTRO_WIZARD_INTRO_CONTENT';
          const introSlidesContentKey = 'INTRO_SLIDES_INTRO_CONTENT'
          const translatedContent = this.translate.instant(introContentKey);
          const translatedIntroSlidesContent = this.translate.instant(introSlidesContentKey);
          const translatedDatasetName = this.translate.instant(this.selectedVectorDbDataset?.name || '');
          this.configdata.IntroDetails = translatedContent.replace('{{display_dataset_name}}', translatedDatasetName);
          this.configdata.ReggieIntroWizard = moduleInfo?.ReggieIntro ?? config?.ReggieIntro.replace("{{display_dataset_name}}", translatedDatasetName);
          this.configdata.ReggieIntro = translatedIntroSlidesContent;
          this.configdata.ReggieDisclaimer = moduleInfo?.ReggieDisclaimer || config?.ReggieDisclaimer;
          this.configdata.ReggieTips = moduleInfo.ReggieTips || config?.ReggieTips;
          this.configdata.PopularQuestionContent = moduleInfo?.PopularQuestionContent || config?.PopularQuestionContent;
          this.configdata.subModuleNames = moduleInfo?.sub_module_names || [];
          this.configdata.isDocChat = moduleInfo?.IsDocChat ?? false;
          this.configdata.is_module_alias = moduleInfo?.is_module_alias ?? false;
          this.configdata.docChatApiUrl = moduleInfo?.RIApiUrl + moduleInfo?.DocChatApiSubUrl;
          this.configdata.ViewFileUrl = moduleInfo?.ViewFileUrl;
          this.configdata.DisplayName = moduleInfo?.DisplayName;
          this.configdata.StreamResponseSubURL = moduleInfo?.StreamResponseSubURL;
          this.configdata.userPrivileges = moduleInfo.USER_PRIVILEGES ? moduleInfo.USER_PRIVILEGES : [];
          this.configdata.RIApiUrl = moduleInfo?.RIApiUrl;
          this.configdata.DownloadApiToggle = moduleInfo?.DownloadApiToggle ?? false;
          this.configdata.DocChatUrl = moduleInfo?.DocChatUrl;
          this.configdata.DisplayName = moduleInfo?.DisplayName;
          this.configdata.RIUIUrl = moduleInfo?.RIUIUrl || '';
          this.configdata.FusionAppUIUrl = config?.FusionAppUIUrl;
          this.configdata.selected_module_name = this.selected_module_name;
          this.configdata.bucket_subfolder = moduleInfo?.bucket_subfolder || this.selected_module_name;
          this.isDocChat = this.configdata.isDocChat;
          this.configdata.api_module_name = moduleInfo?.api_module_name;
          this.configdata.default_tenant_id = this.tenantID;
          this.configdata.DisLikeMessage = moduleInfo?.DisLikeMessage || config.DisLikeMessage;
          this.configdata.FeedbackOptions = moduleInfo?.FeedbackOptions || config.FeedbackOptions;
          this.configdata.default_tenant_id = moduleInfo?.default_tenant_id || this.tenantID
          this.configdata.Countries = this.configdata.MarketsPayloadRequired ? config?.Countries : [];
          this.configdata.schema_name = moduleInfo?.schema_name ?? "";
          this.configdata.RtqDownloadUrl = moduleInfo?.RtqDownloadUrl || (config as any)?.RtqDownloadUrl;
          this.configdata.websocket_url = moduleInfo?.websocket_url || config?.websocket_url;  
          this.configdata.module_name = moduleInfo?.module_name || (config as any)?.module_name;
          if (this.configdata.userPrivileges.length > 0) {
            try {
              const privilegesString = this.Privileges.replace(/^"(.+(?="$))"$/, '$1');
              const privilegesArray = JSON.parse(privilegesString);
              this.configdata.userPrivileges = this.configdata.userPrivileges.filter((privilege: { privilege_name: string }) => privilegesArray.includes(privilege.privilege_name));
              this.IsModuleAccessible = this.configdata.userPrivileges.some((privilege: { module_name: string }) => privilege.module_name === this.moduleName);
            } catch (error) {
              this.IsModuleAccessible = true;
              this.loggerService.logError(this.ChatbotComponentError(error), "parseMetadata");
            }
          }
          else {
            this.IsModuleAccessible = true;
          }
          if (!this.IsModuleAccessible) {
            this.isUserHaveAccess = false;
            this.ChatbotAccessText = "You don't have access to '" + environment.chatbotName + "[" + this.moduleName + "]'. Please contact your system administrator to grant access.";
          }

          if (!this.configdata.is_module_alias && moduleInfo?.sub_module_names?.length > 0) {
            const module_Name = moduleInfo.sub_module_names.find(
              (subModule: any) => subModule.alias === this.moduleName
            );
            this.configdata.module_Name = module_Name?.name;
            this.configdata.actual_module_Name = module_Name?.alias;
          }

        }
      }
    });
  }

  getSelectedOptionLabel(): string {
    if (!this.selectedVectorDbDataset) return '';
    
    const name = this.translate.instant(this.selectedVectorDbDataset.name);
    const favName = this.translate.instant(this.favouriteDataset)
    return name === favName ? `${name} ⭐` : `${name}`;
  }


  toggleHelpMenu() {
    this.showHelpMenu = !this.showHelpMenu;
  }


  openIntroWizard() {
    this.showHelpMenu = false;
    this.showHelp = true;
    this.closeSourcePanel();
  }



  toggleHelp() {
    this.showHelp = !this.showHelp;
  }

  showLoader() {
    this.loaderShow = true;
    this.showEngagingLoader = true; // Reset to show engaging loader for new request
  }

  // Called when you want to hide the loader
  hideLoader() {
    this.loaderShow = false;
  }

  /**
   * Handles conversation saved event and manages chat history ID
   * @param jsonData - The response data containing conversation saved info
   * @param latestObject - The current chat object being processed
   */
  private handleConversationSaved(jsonData: any, latestObject: any): void {
    // Get the chat history ID from the response
    const pk_chat_history_id = jsonData.response_id;
    if (pk_chat_history_id) {
      // Successfully saved with valid ID
      latestObject.pk_chathistoryid = pk_chat_history_id;
      
      // Update the current session's modified_date to now (current UTC time)
      const currentTime = new Date().toISOString();
      if (this.currentSessionId && this.currentSessionId.length > 0) {
        const currentSession = this.currentSessionId[0];
        const sessionIndex = this.chatSessionList.findIndex((item: any) => 
          item.session_id === currentSession.session_id
        );
        
        if (sessionIndex !== -1) {
          // Update the modified_date of the session
          this.chatSessionList[sessionIndex].modified_date = currentTime;
          this.chatSessionList[sessionIndex].is_available = true;
          
          // Reorder the session list: move the current session to the top
          this.chatSessionList = this.chatSessionList.map((item: any) => ({
            ...item,
            is_available: true
          }));
          
          // Sort by modified_date to move the active session to the top
          this.chatSessionList = this.chatSessionList.sort((a: any, b: any) => {
            // Handle 'New Topic' - keep it at top
            if (a.chat_name === 'New Topic') return -1;
            if (b.chat_name === 'New Topic') return 1;
            
            // Sort by modified_date (updated_at) - newest first
            const dateA = a.modified_date ? new Date(a.modified_date).getTime() : 0;
            const dateB = b.modified_date ? new Date(b.modified_date).getTime() : 0;
            return dateB - dateA;
          });
        }
      } else {
        // Fallback: update all sessions as available
        this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_available: true }));
      }

      // Update counts after successful save - increment count for current module
      this.incrementCountAfterSuccessfulSave();

      // Trigger change detection to ensure UI updates with the new pk_chathistoryid
      this.cdr.detectChanges();
      
      // NOW we can safely clean up the streaming subscription since conversation is saved
      if (this.streamingSubscription) {
        this.streamingSubscription.unsubscribe();
        this.streamingSubscription = null;
      }
    } else {
      // Handle error case when chat history ID is null or undefined
      const log_error_message = "Got pk_chat_history_id as null";
      const translatedApologyMsg = this.translate.instant('UNABLE_TO_SAVE_MESSAGE');
      // Mark the session as available so subsequent messages don't increment the count
      if (this.currentSessionId[0]) {
        this.currentSessionId[0].is_available = true;
      }
      
      // Check if this is a new session (1 or fewer responses) or old session
      const isNewSession = this.ChatQueriesList.length <= 1;
      
      if (isNewSession) {
        // For new sessions: Show confirmation popup and redirect to new topic on OK
        this.displaySaveErrorConfirmationPopup(translatedApologyMsg);
      } else {
        // For old sessions: Show simple alert message only
        this.showPopupMessage({
          functionname: "saveChatResponse",
          errorMessage: translatedApologyMsg,
          error: log_error_message
        });
      }
      
      // Clean up streaming subscription even in error case
      if (this.streamingSubscription) {
        this.streamingSubscription.unsubscribe();
        this.streamingSubscription = null;
      }
    }
  }

  universalLoader(value: boolean){
    this.isLoading = value;    
  }

  /**
   * 1. SCROLL DETECTOR - Handles all scroll detection, events, and arrow logic
   */
  private initializeScrollDetector(): void {
    try {
      this.chatContainer = document.querySelector('.chat-expandable-area-new') as HTMLElement;
      if (!this.chatContainer) {
        setTimeout(() => this.initializeScrollDetector(), 100);
        return;
      }
      
      this.chatContainer.addEventListener('scroll', this.handleScrollEvent.bind(this), { passive: true });
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'initializeScrollDetector');
    }
  }

  private handleScrollEvent(): void {
    if (!this.chatContainer) return;

    // For streaming interruption, detect immediately without debounce
    if (this.IsResponseStreaming && this.isAutoScrolling) {
      this.checkStreamingInterruption();
    }

    // Debounce scroll events
    if (this.scrollDebounceTimeout) {
      clearTimeout(this.scrollDebounceTimeout);
    }

    // Use shorter debounce for more responsive interruption
    this.scrollDebounceTimeout = setTimeout(() => {
      this.updateScrollState();
      this.updateArrowVisibility();
      this.handleUserScrollBehavior();
    }, 5);
  }

  private checkStreamingInterruption(): void {
    if (!this.chatContainer) return;

    const currentScrollTop = this.chatContainer.scrollTop;
    
    // If user is actively scrolling up during streaming, stop auto-scroll immediately
    if (currentScrollTop < this.lastScrollTop - 5) { // More sensitive threshold
      this.userHasScrolledUp = true;
      this.isAutoScrolling = false; // Stop auto-scrolling immediately
      
      // Cancel any pending auto-scroll operations
      if (this.autoScrollTimeout) {
        clearTimeout(this.autoScrollTimeout);
        this.autoScrollTimeout = null;
      }
    }
  }

  private updateScrollState(): void {
    if (!this.chatContainer) return;

    const currentScrollTop = this.chatContainer.scrollTop;
    const scrollHeight = this.chatContainer.scrollHeight;
    const clientHeight = this.chatContainer.clientHeight;
    const distanceFromBottom = scrollHeight - (currentScrollTop + clientHeight);

    this.isNearBottom = distanceFromBottom <= 20;
    
    // More sensitive detection for manual scroll up during streaming
    const scrollThreshold = this.IsResponseStreaming ? 3 : this.scrollDetectionThreshold; // More sensitive during streaming
    
    // Detect manual scroll up (ignore auto-scrolling)
    if (!this.isAutoScrolling && currentScrollTop < this.lastScrollTop - scrollThreshold) {
      this.userHasScrolledUp = true;
      
      // If user scrolls up during streaming, immediately stop auto-scroll
      if (this.IsResponseStreaming) {
        this.isAutoScrolling = false; // Stop immediately
        if (this.autoScrollTimeout) {
          clearTimeout(this.autoScrollTimeout);
          this.autoScrollTimeout = null;
        }
      }
    }

    // Reset scroll-up state when user returns to bottom
    if (this.isNearBottom && this.userHasScrolledUp) {
      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => {
        this.userHasScrolledUp = false;
      }, 300); // Reduced from 500ms to 300ms for faster re-enablement
    }

    if (!this.isAutoScrolling) {
      this.lastScrollTop = currentScrollTop;
    }
  }

  private updateArrowVisibility(): void {
    if (!this.chatContainer) return;

    const scrollHeight = this.chatContainer.scrollHeight;
    const clientHeight = this.chatContainer.clientHeight;
    const hasScrollableContent = scrollHeight > clientHeight;
    
    this.showScrollToBottomArrow = hasScrollableContent && !this.isNearBottom && this.userHasScrolledUp;
  }


  /**
   * 2. SCROLL MANAGER - Unified scroll execution with multiple methods and reliability
   */
  private executeScroll(options: {
    type: 'smooth' | 'immediate' | 'auto';
    target?: 'bottom' | 'followup';
    reliable?: boolean;
  }): void {
    try {
      if (!this.isResponseScroll && options.type !== 'auto') return;

      const { type, target = 'bottom', reliable = false } = options;

      if (reliable) {
        this.executeReliableScroll(type === 'auto' ? 'immediate' : type);
        return;
      }

      switch (type) {
        case 'immediate':
          this.performImmediateScroll();
          break;
        case 'smooth':
          this.performSmoothScroll(target);
          break;
        case 'auto':
          this.performAutoScroll();
          break;
      }
    } catch (err) {
      this.loggerService.logError(this.ChatbotComponentError(err), 'executeScroll');
    }
  }

  private performImmediateScroll(): void {
    if (!this.chatContainer) {
      this.chatContainer = document.querySelector('.chat-expandable-area-new') as HTMLElement;
    }
    
    if (this.chatContainer) {
      this.chatContainer.scrollTop = this.chatContainer.scrollHeight;
    } else {
      const responseArea = document.querySelector('.response-history-area-new') as HTMLElement;
      if (responseArea) {
        responseArea.scrollTop = responseArea.scrollHeight;
      }
    }
  }

  private performSmoothScroll(target: 'bottom' | 'followup'): void {
    if (target === 'followup') {
    }

    // Always scroll to bottom for better UX
    const scrollTarget = document.getElementById('scrolltobottom') as HTMLElement;
    if (scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'end' });
    } else if (this.chatContainer) {
      this.chatContainer.scrollTo({ top: this.chatContainer.scrollHeight, behavior: 'smooth' });
    }
  }

  private performAutoScroll(): void {
    // This method is now handled by autoScrollDuringStreaming for better control
    this.autoScrollDuringStreaming();
  }

  /**
   * 3. SCROLL CONTROLLER - Main controller for different scroll scenarios
   */
  public scrollToBottom(reliable: boolean = false): void {
    this.executeScroll({ type: 'smooth', reliable });
  }

  public scrollToBottomImmediate(): void {
    this.executeScroll({ type: 'immediate' });
  }

  public scrollToBottomSmooth(): void {
    this.executeScroll({ type: 'smooth' });
  }

  public scrollToBottomIfAllowed(): void {
    if (this.userHasScrolledUp && !this.isNearBottom) {
      return;
    }
    this.executeScroll({ type: 'smooth' });
  }

  public onScrollToBottomArrowClick(): void {
    this.resetScrollState({ userScrolled: false, showArrow: false });
    this.executeScroll({ type: 'smooth' });
  }

  public scrollToFollowupQuestions(): void {
    // Changed behavior: Instead of scrolling to middle (followup), scroll to bottom
    // This keeps follow-up questions visible without jarring scroll experience
    if (this.userHasScrolledUp && !this.isNearBottom) return;
    setTimeout(() => {
      this.executeScroll({ type: 'smooth', target: 'bottom' });
    }, 300);
  }

  private autoScrollDuringStreaming(): void {
    try {
      // Don't auto scroll if user has manually scrolled up and we're not near bottom
      if (this.userHasScrolledUp && !this.isNearBottom) {
        return;
      }

      // Only auto-scroll if we're actually streaming a response
      if (!this.IsResponseStreaming || !this.isResponseScroll) {
        return;
      }

      // Throttle auto-scroll to reduce fighting with user input
      const now = Date.now();
      if (this.lastAutoScrollTime && now - this.lastAutoScrollTime < 100) { // Throttle to max 10 scrolls per second
        return;
      }

      this.lastAutoScrollTime = now;
      
      // Set flag to indicate we're auto-scrolling
      this.isAutoScrolling = true;

      // Use requestAnimationFrame for smooth scrolling during streaming
      requestAnimationFrame(() => {
        // Double-check user hasn't started scrolling before we auto-scroll
        if (this.userHasScrolledUp && !this.isNearBottom) {
          this.isAutoScrolling = false;
          return;
        }

        this.performGentleScroll();
        
        // Clear auto-scroll flag faster for more responsive interruption
        this.autoScrollTimeout = setTimeout(() => {
          this.isAutoScrolling = false;
        }, 25); // Reduced from 50ms to 25ms
      });
    } catch (err) {
      this.loggerService.logError(this.ChatbotComponentError(err), 'autoScrollDuringStreaming');
      this.isAutoScrolling = false;
    }
  }

  private performGentleScroll(): void {
    try {
      if (!this.chatContainer) return;

      // Use smaller scroll increments to be less aggressive
      const currentScrollTop = this.chatContainer.scrollTop;
      const scrollHeight = this.chatContainer.scrollHeight;
      const clientHeight = this.chatContainer.clientHeight;
      const maxScrollTop = scrollHeight - clientHeight;

      // If we're close to the bottom, just scroll to the very bottom
      if (maxScrollTop - currentScrollTop < 100) {
        this.chatContainer.scrollTop = maxScrollTop;
      } else {
        // Otherwise, scroll incrementally to be less jarring
        const targetScroll = Math.min(currentScrollTop + 50, maxScrollTop);
        this.chatContainer.scrollTop = targetScroll;
      }
    } catch (err) {
      this.loggerService.logError(this.ChatbotComponentError(err), 'gentleScrollToBottom');
    }
  }

  /**
   * 4. SCROLL VALIDATOR - Position validation and retry logic
   */
  public onScrollToBottomAfterSession(): void {
    this.resetScrollState({ userScrolled: false, showArrow: false });
    this.executeReliableScroll('smooth');
  }

  private executeReliableScroll(type: 'smooth' | 'immediate'): void {
    this.waitForContent().then(() => {
      this.performScrollWithValidation(type);
    }).catch(err => {
      this.loggerService.logError(this.ChatbotComponentError(err), 'scrollToBottomAfterContentLoad');
      this.performScrollWithValidation(type);
    });
  }

  private waitForContent(): Promise<void> {
    return new Promise((resolve, reject) => {
      let retryCount = 0;
      const maxRetries = 10;

      const checkContent = () => {
        if (!this.chatContainer) {
          this.chatContainer = document.querySelector('.chat-expandable-area-new') as HTMLElement;
        }

        if (!this.chatContainer) {
          retryCount++;
          if (retryCount < maxRetries) {
            setTimeout(checkContent, 100);
            return;
          }
          reject('Chat container not found');
          return;
        }

        if (this.ChatQueriesList.length === 0 && retryCount < maxRetries) {
          retryCount++;
          setTimeout(checkContent, 150);
          return;
        }

        resolve();
      };

      checkContent();
    });
  }

  private performScrollWithValidation(type: 'smooth' | 'immediate'): void {
    let attempt = 0;
    const maxAttempts = 5;

    const attemptScroll = () => {
      attempt++;

      this.waitForImages().then(() => {
        this.performScrollAction(type);
        
        setTimeout(() => {
          if (this.validateScrollPosition() || attempt >= maxAttempts) {
            this.finalizeScroll();
          } else {
            setTimeout(attemptScroll, 300);
          }
        }, type === 'smooth' ? 600 : 100);
      });
    };

    attemptScroll();
  }

  private waitForImages(): Promise<void> {
    return new Promise((resolve) => {
      if (!this.chatContainer) {
        resolve();
        return;
      }

      const images = this.chatContainer.querySelectorAll('img');
      if (images.length === 0) {
        resolve();
        return;
      }

      let loadedCount = 0;
      const timeout = setTimeout(() => resolve(), 2000);

      images.forEach(img => {
        if (img.complete) {
          loadedCount++;
        } else {
          const onLoad = () => {
            loadedCount++;
            if (loadedCount === images.length) {
              clearTimeout(timeout);
              resolve();
            }
          };
          img.addEventListener('load', onLoad);
          img.addEventListener('error', onLoad);
        }
      });

      if (loadedCount === images.length) {
        clearTimeout(timeout);
        resolve();
      }
    });
  }

  private performScrollAction(type: 'smooth' | 'immediate'): void {
    if (!this.chatContainer) return;

    const scrollHeight = this.chatContainer.scrollHeight;
    
    if (type === 'smooth') {
      this.chatContainer.scrollTo({ top: scrollHeight, behavior: 'smooth' });
    } else {
      this.chatContainer.scrollTop = scrollHeight;
    }
  }

  private validateScrollPosition(): boolean {
    if (!this.chatContainer) return false;

    const scrollTop = this.chatContainer.scrollTop;
    const scrollHeight = this.chatContainer.scrollHeight;
    const clientHeight = this.chatContainer.clientHeight;
    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

    return distanceFromBottom <= 15;
  }

  private finalizeScroll(): void {
    setTimeout(() => {
      this.updateScrollState();
      this.updateArrowVisibility();
    }, 300);
  }

  /**
   * 5. SCROLL STATE - State management and configuration
   */
  private resetScrollState(options?: { 
    userScrolled?: boolean; 
    showArrow?: boolean; 
    nearBottom?: boolean; 
    lastScrollTop?: number; 
  }): void {
    if (options?.userScrolled !== undefined) this.userHasScrolledUp = options.userScrolled;
    if (options?.showArrow !== undefined) this.showScrollToBottomArrow = options.showArrow;
    if (options?.nearBottom !== undefined) this.isNearBottom = options.nearBottom;
    if (options?.lastScrollTop !== undefined) this.lastScrollTop = options.lastScrollTop;
    
    // Default reset
    if (!options) {
      this.userHasScrolledUp = false;
      this.showScrollToBottomArrow = false;
      this.isNearBottom = true;
      this.lastScrollTop = 0;
      this.lastAutoScrollTime = 0;
    }

    // Clear any existing timeouts
    if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
    if (this.scrollDebounceTimeout) clearTimeout(this.scrollDebounceTimeout);
    if (this.autoScrollTimeout) clearTimeout(this.autoScrollTimeout);
  }

  private handleUserScrollBehavior(): void {
    // Clear existing timeout
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }


  ngAfterViewChecked() {
    try {
      if (this.elementRef.nativeElement.querySelector('#download-click')) {
        const elements = this.elementRef.nativeElement.querySelectorAll('#download-click');
      }

      this.updateMarkdownLinks();
      this.updateTableClasses();
      this.updateLatexScrollbars();
    }
    catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), "ngAfterViewChecked");
    }
  }

  VerifyUserAccessToChatBot(UserID: any, DomainID: any) {
    try {
      this.isUserHaveAccess = true;
    }
    catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), "VerifyUserAccessToChatBot");
    }
  }

  GetDomainName() {
    if (environment.DomainName != null && environment.DomainName != "") {
      environment.DomainName = environment.DomainName.replace(/^"(.+(?="$))"$/, '$1');
    } else {
      environment.DomainName = this.configdata.DomainName;
    }
    this.moduleName = environment.DomainName;
  }

  isRegulationsModuleSelected(): boolean {
    return this.selectedVectorDbDataset?.value === 'view_access_to_regulations';
  }

  get showRetrievalModeToggle(): boolean {
    return this.isRetrievalModeFeatureEnabled && this.isRegulationsModuleSelected();
  }

  resetChatState() {
    this.isResponseScroll = false;
    this.IsResponseStreaming = false;
    this.isOptionsEnable = true;
    this.IsFirstTime = false;
    this.IsNewChat = false;
    this.txtChat = "";
    this.followUpQuestions = [];
    this.followUpQuestionsShow = false;
    
    // Clear all file uploads when resetting chat state (session switching)
    this.clearFileUploads();
  }

  handleChange() {
    this.scrollToBottomSmooth();
    this.note = false;
    
    // Ensure selectedVectorDbDataset is valid before using it
    this.ensureValidSelectedDataset();
    
    let sendVectorDbObj: any = {};
    sendVectorDbObj.type = 1;
    sendVectorDbObj.selectedVectorDbDataset = this.selectedVectorDbDataset;

    this.sharedService.changeSelectedValue(sendVectorDbObj);
    this.GetDomainName();
    
    // Clear all file uploads when switching modules
    this.clearFileUploads();
    
    this.ClickNewChat(true);
    this.stopStreaming();
    
    // Fetch chat sessions for the newly selected module
    // Remove existing sessions for the newly selected module to avoid duplicates
    const newModuleName = this.selectedVectorDbDataset?.name?.toLowerCase();
    if (newModuleName) {
      this.chatSessionList = this.chatSessionList.filter((session: any) => 
        session.module_name?.toLowerCase() !== newModuleName || 
        session.chat_name === 'New Topic'
      );
    }
    
    // Reset pagination only for the current module (not all modules)
    this.currentPage = 1;
    this.hasMoreData = true;
    
    // Fetch sessions for the newly selected module
    this.GetChatSessionsInfo({ UserID: this.UserID, DomainID: this.DomainID });
  }

  private formatDateToDB(date: Date): string {
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    const seconds = date.getUTCSeconds().toString().padStart(2, '0');
    const milliseconds = date.getUTCMilliseconds().toString().padStart(3, '0');
    // Pad milliseconds to 6 digits (microseconds)
    const microseconds = milliseconds + '000';
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${microseconds}`;
  }

  updateFilter(filter: string): void {
    this.selectedFilter = filter;
    this.resetPaginationState();
    this.GetChatSessionsInfo({ UserID: this.UserID, DomainID: this.DomainID });
  }

  private resetPaginationState(): void {
    this.currentPage = 1;
    this.chatSessionList = [];
    this.hasMoreData = true;
    this.isLoadingsession = false;
    this.moduleThreadsCounts = {}; // Reset per-module counts
    
    // Reset dataset-specific pagination states
    Object.keys(this.datasetPagination).forEach(datasetName => {
      this.datasetPagination[datasetName] = {
        currentPage: 1,
        hasMoreData: true
      };
    });
    
    // Reset dataset loading states
    Object.keys(this.datasetLoadingStates).forEach(datasetName => {
      this.datasetLoadingStates[datasetName] = false;
    });
  }

  private loadInitialChatSessions(): void {
    this.resetPaginationState();
    this.GetChatSessionsInfo({ UserID: this.UserID, DomainID: this.DomainID });
  }

  loadMoreChatSessions(event?: { datasetName: string }): void {
    if (this.isLoadingsession) {
      return;
    }

    if (event && event.datasetName) {
      // Dataset-specific lazy loading
      // Check dataset-specific loading state
      if (this.datasetLoadingStates[event.datasetName]) {
        return;
      }
      this.loadMoreSessionsForDataset(event.datasetName);
    } else {
      // General lazy loading (original behavior)
      if (!this.hasMoreData) {
        return;
      }
      // Set loading state immediately to prevent race conditions
      this.isLoadingsession = true;
      this.GetChatSessionsInfo({ UserID: this.UserID, DomainID: this.DomainID });
    }
  }

  async transformNewSessionDataToOldFormat(newData: any[]): Promise<any[]> {
    // Handle case where newData is not an array
    if (!Array.isArray(newData)) {
      return [];
    }
    
    return newData.map((item: any) => ({
      session_id: item.thread_id,
      user_id: parseInt(item.user_id) || item.user_id,
      tenant_id: parseInt(item.tenant_id) || item.tenant_id,
      chat_name: item.thread_name,
      created_date: item.created_at,
      modified_date: item.updated_at,
      domain_id: item.selected_domains && item.selected_domains.length > 0 ? item.selected_domains[0] : '',
      status: item.status ? 1 : 0, // Convert boolean to number
      module_name: item.modules && item.modules.length > 0 ? item.modules[0] : '',
      original_name: item.thread_name,
    }));
  }

  async GetChatSessionsInfo(event: GetChatSessionsInfoEvent): Promise<void> {
    
    if (this.isLoadingsession) return; // Prevent multiple simultaneous requests

    const endDate = new Date();
    let days: number;
    switch (this.selectedFilter) {
      case '7 Days':
        days = 7;
        break;
      case '15 Days':
        days = 15;
        break;
      case '30 Days':
        days = 30;
        break;
      default:
        days = 30;
    }
    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - days);

    const startDateFormatted = this.formatDateToDB(startDate);
    const endDateFormatted = this.formatDateToDB(endDate);
    const version = 2;
    // fetch privilege dataset modules
    const selectedDomain = this.isDomainManagementEnabled ? this.getSelectedDomains() : [environment.DomainName];
    const modules: string[] = [this.selectedVectorDbDataset?.name || 'Regulations'];
  
    this.isLoadingsession = true;
    this.chatbotService.GetChatSessions(event.UserID, this.tenantID, selectedDomain, this.currentPage, this.pageSize, startDateFormatted, endDateFormatted, version, modules,this.isDomainManagementEnabled).subscribe({
      next: async (response: any) => {
          this.hideLoader();
          this.isLoadingsession = false;
          if (response.status === 200) {
              if (response.body && response.body.data) {
                  // Initialize an array to hold all sessions
                  const allSessions = [];
  
                  // Iterate through each module in the response data
                  for (const module in response.body.data) {
                        if (response.body.data.hasOwnProperty(module)) {
                            const sessions = response.body.data[module];
                            
                            // Store module-specific total count (for the first page only)
                            if (this.currentPage === 1 && response.body.total !== undefined) {
                                this.moduleThreadsCounts[module.toLowerCase()] = response.body.total;
                                // Mark this dataset as having had its API triggered
                                this.datasetApiTriggered[module.toLowerCase()] = true;
                            }         
                            // Check if sessions exist and are an array
                          const transformedSessions = await this.transformNewSessionDataToOldFormat(sessions);
                          if (Array.isArray(transformedSessions)) {
                              const newSessions = transformedSessions.map((item: any) => ({ ...item, isChecked: false }));
                              allSessions.push(...newSessions); // Add new sessions to the allSessions array
                          }
                      }
                  }
  
                  // Update chatSessionList with all sessions
                  if (this.currentPage === 1) {
                      // Preserve sessions from other modules when loading first page for a specific module
                      const currentModuleName = this.selectedVectorDbDataset?.name?.toLowerCase();
                      const existingSessionsFromOtherModules = this.chatSessionList.filter((session: any) => 
                        session.module_name?.toLowerCase() !== currentModuleName || 
                        session.chat_name === 'New Topic'
                      );
                      
                      // Merge: Keep sessions from other modules (and 'New Topic') + new sessions from current module
                      this.chatSessionList = [...existingSessionsFromOtherModules, ...allSessions];
                      
                      // Sort all sessions by modified_date (updated_at) in descending order to maintain chronological order
                      // This ensures sessions maintain their original API order regardless of tab switching
                      this.chatSessionList = this.chatSessionList.sort((a: any, b: any) => {
                        // Handle 'New Topic' - keep it at top
                        if (a.chat_name === 'New Topic') return -1;
                        if (b.chat_name === 'New Topic') return 1;
                        
                        // Sort by modified_date (updated_at) - newest first
                        const dateA = a.modified_date ? new Date(a.modified_date).getTime() : 0;
                        const dateB = b.modified_date ? new Date(b.modified_date).getTime() : 0;
                        return dateB - dateA;
                      });
                      
                      this.IsFirstTime = false;
                      this.IsNewChat = false;
                      if (this.chatSessionList.length <= 0) {
                          this.chatSessionList = [];
                      }
                      // Set flag to indicate this is automatic session initialization
                      this.isAutoSessionCreation = true;
                      this.ClickNewChat(true);
                      this.isAutoSessionCreation = false;
                  } else {
                      // Subsequent pages: Append to the list
                      this.chatSessionList = [...this.chatSessionList, ...allSessions];
                  }
  
                  // Check if there is more data to load and only increment page if data was received
                  if (allSessions.length > 0) {
                      this.currentPage++;
                      // Check if there is more data to load
                      if (allSessions.length < this.pageSize) {
                          this.hasMoreData = false;
                      }
                  } else {
                      // No data received, stop pagination
                      this.hasMoreData = false;
                  }
  
                  this.ConversationHistoryCount = this.getConversationHistoryCount();
              } else {
                  if (this.currentPage === 1) {
                      this.chatSessionList = [];
                      this.IsFirstTime = true;
                      this.IsNewChat = false;
                        this.moduleThreadsCounts = {}; // Reset module counts when no data
                    }
                    this.hasMoreData = false;
                    this.ConversationHistoryCount = 0;
              }
          } else {
              this.hasMoreData = false;
              if (this.currentPage === 1) {
                  this.chatSessionList = [];
                  this.moduleThreadsCounts = {}; // Reset module counts on error
              }
              this.IsCustomErrorMessageVisible = true;
              const translatedApologyMsg = this.translate.instant('APOLOGY_MESSAGE_DEFAULT');
              this.CustomErrorMessageText = translatedApologyMsg;
              setTimeout(() => {
                  this.IsCustomErrorMessageVisible = false;
              }, 4000);
          }
      },
      error: (error) => {
          this.hideLoader();
          this.isLoadingsession = false;
          this.hasMoreData = false;
          if (this.currentPage === 1) {
              this.chatSessionList = [];
              this.moduleThreadsCounts = {}; // Reset module counts on error
          }
          this.IsCustomErrorMessageVisible = true;
          const translatedApologyMsg = this.translate.instant('APOLOGY_MESSAGE_DEFAULT');
          this.CustomErrorMessageText = translatedApologyMsg;
          setTimeout(() => {
              this.IsCustomErrorMessageVisible = false;
          }, 4000);
      },
      complete: () => {
          // Handle completion if necessary
      }
  });
  }


  ClickNewChat(isNewChatSession: boolean) {
    // Always clear the prompt input when starting a new chat from any trigger
    this.txtChat = "";
    // Only show popup for user-initiated actions, not automatic session creation
    const isAgentStreaming = this.streamingStateService?.getCurrentStreamingState() || false;
    
    // Check agent streaming FIRST (higher priority)
    if (!this.isAutoSessionCreation && isAgentStreaming) {
      // Agent is streaming - show CHATBOT's own popup for agent switch
      this.pendingNewChatSession = isNewChatSession;
      this.showAgentSwitchConfirmationPopup = true;
      return;
    } else if (!this.isAutoSessionCreation && (this.IsResponseStreaming || this.loaderShow || this.isProcessing || this.streamingSubscription)) {
      // Chatbot is streaming - show chatbot popup
      this.pendingNewChatSession = isNewChatSession;
      this.showNewChatConfirmationPopup = true;
      return;
    }

    if (this.agentOrchestrator) {
      this.agentOrchestrator.resetToModule();
    }
    
    if (this.chatbotService.AllWebSocketsConnectionsOpen() || this.chatbotService.isWebSocketOpen() || this.chatbotService.isNewsWebSocketOpen() || this.chatbotService.isFileStatusTrackerWebSocketOpen()) {
      this.chatbotService.closeAllWebSockets();
    }
    this.closeSourcePanel();
    // Hide scroll arrow when starting new chat
    this.showScrollToBottomArrow = false;
    this.userHasScrolledUp = false;
    
    // Clear all file uploads when starting new chat
    this.clearFileUploads();
    
    // Clean up all chat-related state tracking
    this.responseLoadingStates = {};
    this.newsLoadingStates = {};
    this.newsErrorStates = {};
    this.pendingNewsWebSocketSave = {};
    this.websocketCompleteAndDataSaved = {};
    
    if (this.audioCopies) {
      this.audioCopies.forEach(audioCopy => audioCopy.stopSpeaking());
    }
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.adjustHeight();
      }
    });
    if (this.IsResponseStreaming) {
      const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
      let chatSessionName = this.extractChatSessionName(this.currentSessionId[0].chat_name);
      this.stopStreaming();
      this.txtChat = "";
    }
    this.IsResponseStreaming = false;
    this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_selected: false }));

    this.isResponseScroll = true;
    let newChatItem = this.chatSessionList.filter((item: { chat_name: any; }) =>
      item.chat_name == "New Topic"
    );
    this.updateCurrentSessionId();
    if (!this.IsNewChat && isNewChatSession) {
      this.ChatQueriesList = [];
      this.IsNewChat = true;
      if (newChatItem.length == 0) {
        this.chatSessionList = this.chatSessionList?.map((item: any) => ({ ...item, is_selected: false }));
        const newItem = { session_id: this.globalConfigService.generateRequestId(), user_id: this.UserID, chat_name: "New Topic", domain_id: this.DomainID, is_selected: true, is_edited: false, original_name: "New Topic", is_available: false };
        if (this.chatSessionList && this.chatSessionList.length > 0) {
          this.chatSessionList.unshift(newItem);
        }
        else {
          this.chatSessionList.push(newItem);
        }
      }
    }
  }


  // ✅ Agent Landing Page Methods (no dependency on agents folder)
  
  /**
   * Handle agent selection from sidebar
   * @param agentId - The ID of the selected agent ('module', 'Via', etc.)
   */
  handleAgentSelectionFromSidebar(agentId: string): void {
    // Check if currently processing (include both chatbot AND agent streaming states)
    const chatbotProcessing = this.IsResponseStreaming || this.loaderShow || this.isProcessing || !!this.streamingSubscription;
    const agentStreaming = this.streamingStateService?.getCurrentStreamingState() || false;
    const isProcessing = chatbotProcessing || agentStreaming;
    
    // If chatbot is streaming, show chatbot->agent confirmation popup
    if (chatbotProcessing && !agentStreaming) {
      // Store current agent ID BEFORE showing popup (in case user cancels)
      this.previousAgentId = this.agentOrchestrator.getCurrentAgentId();
      this.pendingAgentId = agentId;
      this.showChatbotToAgentConfirmationPopup = true;
      return; // Don't call orchestrator yet - wait for confirmation
    }
    
    // Delegate to orchestrator
    const needsConfirmation = this.agentOrchestrator.handleAgentSelection(agentId, isProcessing);
    
    // If needs confirmation (agent is streaming), show popup
    if (needsConfirmation) {
      this.showNewChatConfirmationPopup = true;
      return;
    }
    
    // Otherwise, complete the switch by resetting chat
    this.completeAgentSwitch();
  }

  /**
   * Complete agent switch after orchestrator has updated state
   */
  private completeAgentSwitch(): void {
    // Start fresh chat session
    this.IsNewChat = true;
    this.ChatQueriesList = [];
    this.ClickNewChat(true);
  }
  
  /**
   * ⚠︝ DEPRECATED: No longer used - agent-chat-container handles this internally
   * Handle prompt selection from agent landing page
   * @param promptText - The selected prompt text
   */


  /**
   * Check if agent landing page should be shown
   */
  get shouldShowAgentLanding(): boolean {
    return this.agentOrchestrator.shouldShowAgentLanding(this.IsNewChat, this.ChatQueriesList.length);
  }

  /**
   * Check if we're in agent mode (not module/regular chatbot)
   */
  get isInAgentMode(): boolean {
    const currentAgentId = this.agentOrchestrator.getCurrentAgentId();
    return currentAgentId !== 'module' && currentAgentId !== '';
  }
  
  /**
   * Get current agent ID from orchestrator
   */
  get currentAgentId(): string {
    return this.agentOrchestrator.getCurrentAgentId();
  }

  /**
   * ⚠︝ DEPRECATED: No longer used - agent-chat-container handles this internally
   * Handler for prompt section send request
   * This is called by the prompt-section component
   */

  confirmNewChatWhileStreaming(): void {
    // Hide the popup first
    this.showNewChatConfirmationPopup = false;
    
    // ✅ ADD: Reset agent to module mode when confirming new chat
    if (this.agentOrchestrator) {
      // Cancel any pending agent switch first
      this.agentOrchestrator.cancelPendingSwitch();
      // Reset to module
      this.agentOrchestrator.resetToModule();
    }

    // Re-check current processing state (request might have completed while popup was open)
    if (!this.isCurrentlyProcessing()) {
      // Response completed while popup was open
      
      // Check if this was an agent switch confirmation
      const agentId = this.agentOrchestrator.confirmPendingSwitch();
      if (agentId) {
        // Complete the agent switch
        this.completeAgentSwitch();
        return;
      }
      
      // Continue with normal new chat logic (don't remove current session since response completed)
      this.ClickNewChat(this.pendingNewChatSession);
      this.pendingNewChatSession = false;
      return;
    }
    
    // Response is still streaming - proceed with original logic
    // Check if current session has 1 or fewer questions and remove it
    this.removeCurrentSessionIfSingleQuestion();
    
    // Stop the streaming
    this.stopStreaming();
    this.txtChat = "";
    
    // Check if this was an agent switch confirmation
    const agentId = this.agentOrchestrator.confirmPendingSwitch();
    if (agentId) {
      // Complete the agent switch
      this.completeAgentSwitch();
    } else {
      // Continue with normal new chat logic
      this.ClickNewChat(this.pendingNewChatSession);
      
      // Reset the pending state
      this.pendingNewChatSession = false;
    }
  }

    cancelNewChatWhileStreaming(): void {
    // Simply hide the popup and reset state
    this.showNewChatConfirmationPopup = false;
    this.pendingNewChatSession = false;
    
    // Cancel any pending agent switch
    this.agentOrchestrator.cancelPendingSwitch();
  }

  /**
   * Confirm switching from agent streaming to chatbot new topic
   */
  confirmAgentSwitchToChatbot(): void {
    try {
      this.showAgentSwitchConfirmationPopup = false;
      
      if (this.pendingNewChatSession !== null) {
        // Reset agent to module mode first (this will stop streaming)
        if (this.agentOrchestrator) {
          this.agentOrchestrator.resetToModule(); // This now properly stops streaming
        }
        
        // Ensure streaming state is completely cleared
        this.streamingStateService.setStreamingState(false);
        
        // Clear all chatbot processing states that might be leftover from agent switch
        this.loaderShow = false;
        this.isProcessing = false;
        this.IsResponseStreaming = false;
        if (this.streamingSubscription) {
          this.streamingSubscription.unsubscribe();
          this.streamingSubscription = null;
        }
        
        // Execute new chat logic directly WITHOUT triggering popup logic again
        this.executeNewChatLogic(this.pendingNewChatSession, true); // true = from agent switch
        this.pendingNewChatSession = false;
      }
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'confirmAgentSwitchToChatbot');
    }
  }

  /**
   * Execute core new chat logic without popup checks (for confirmation scenarios)
   * @param isNewChatSession - Whether this is a new chat session
   * @param fromAgentSwitch - Whether this is called from agent switch confirmation (optional)
   */
  private executeNewChatLogic(isNewChatSession: boolean, fromAgentSwitch: boolean = false): void {
    try {
      // Only reset agent if NOT coming from agent switch confirmation (to avoid double reset)
      if (this.agentOrchestrator && !fromAgentSwitch) {
        this.agentOrchestrator.resetToModule();
      }
      
      if (this.chatbotService.AllWebSocketsConnectionsOpen() || this.chatbotService.isWebSocketOpen() || this.chatbotService.isNewsWebSocketOpen() || this.chatbotService.isFileStatusTrackerWebSocketOpen()) {
        this.chatbotService.closeAllWebSockets();
      }
      this.closeSourcePanel();
      
      // Hide scroll arrow when starting new chat
      this.showScrollToBottomArrow = false;
      this.userHasScrolledUp = false;
      
      // Clear all file uploads when starting new chat
      this.clearFileUploads();
      
      // Clean up all chat-related state tracking
      this.responseLoadingStates = {};
      this.newsLoadingStates = {};
      this.newsErrorStates = {};
      this.pendingNewsWebSocketSave = {};
      this.websocketCompleteAndDataSaved = {};
      
      if (this.audioCopies) {
        this.audioCopies.forEach(audioCopy => audioCopy.stopSpeaking());
      }
      
      setTimeout(() => {
        if (this.autoResizeDirective) {
          this.autoResizeDirective.adjustHeight();
        }
      });
      
      if (this.IsResponseStreaming) {
        const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
        let chatSessionName = this.extractChatSessionName(this.currentSessionId[0]?.chat_name);
        this.stopStreaming();
        this.txtChat = "";
      }
      
      this.IsResponseStreaming = false;
      this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_selected: false }));

      this.isResponseScroll = true;
      let newChatItem = this.chatSessionList.filter((item: { chat_name: any; }) =>
        item.chat_name == "New Topic"
      );
      this.updateCurrentSessionId();
      
      if (!this.IsNewChat && isNewChatSession) {
        this.ChatQueriesList = [];
        this.IsNewChat = true;
        if (newChatItem.length == 0) {
          this.chatSessionList = this.chatSessionList?.map((item: any) => ({ ...item, is_selected: false }));
          const newItem = { session_id: this.globalConfigService.generateRequestId(), user_id: this.UserID, chat_name: "New Topic", domain_id: this.DomainID, is_selected: true, is_edited: false, original_name: "New Topic", is_available: false };
          if (this.chatSessionList && this.chatSessionList.length > 0) {
            this.chatSessionList.unshift(newItem);
          }
          else {
            this.chatSessionList.push(newItem);
          }
        }
      }
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'executeNewChatLogic');
    }
  }

  /**
   * Cancel switching from agent to chatbot
   */
  cancelAgentSwitchToChatbot(): void {
    try {
      this.showAgentSwitchConfirmationPopup = false;
      this.pendingNewChatSession = false;
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'cancelAgentSwitchToChatbot');
    }
  }

  /**
   * Confirm switching from chatbot to agent while streaming
   */
  confirmChatbotToAgentSwitch(): void {
    try {
      this.showChatbotToAgentConfirmationPopup = false;
      
      // Stop chatbot streaming
      this.stopStreaming();
      
      // Clear all chatbot processing states
      this.loaderShow = false;
      this.isProcessing = false;
      this.IsResponseStreaming = false;
      if (this.streamingSubscription) {
        this.streamingSubscription.unsubscribe();
        this.streamingSubscription = null;
      }
      
      // Now switch to the agent
      const agentId = this.pendingAgentId;
      this.pendingAgentId = '';
      
      // Delegate to orchestrator (no processing now, so no confirmation needed)
      this.agentOrchestrator.handleAgentSelection(agentId, false);
      
      // Complete the switch
      this.completeAgentSwitch();
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'confirmChatbotToAgentSwitch');
    }
  }

  /**
   * Cancel switching from chatbot to agent
   */
  cancelChatbotToAgentSwitch(): void {
    try {
      this.showChatbotToAgentConfirmationPopup = false;
      
      // Reset back to the previous agent (should be 'module' for chatbot)
      // This will update the sidebar selection to show chatbot as selected
      if (this.previousAgentId === 'module') {
        this.agentOrchestrator.resetToModule();
      } else {
        // If somehow we were on another agent, switch back to it
        this.agentOrchestrator.handleAgentSelection(this.previousAgentId, false);
      }
      
      // Clear pending states
      this.pendingAgentId = '';
      this.previousAgentId = 'module';
      
      // Don't stop streaming - user wants to continue with current chatbot response
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'cancelChatbotToAgentSwitch');
    }
  }

  private removeCurrentSessionIfSingleQuestion(): void {
    // Check if current session has 1 or fewer questions and remove it
    if (this.ChatQueriesList.length <= 1 && this.currentSessionId && this.currentSessionId.length > 0) {
      const currentSession = this.currentSessionId[0];
      if (currentSession && currentSession.session_id) {
        // Remove the current session from the session list
        this.chatSessionList = this.chatSessionList.filter((item: any) => 
          item.session_id !== currentSession.session_id
        );
      }
    }
  }

  private isCurrentlyProcessing(): boolean {
    return this.IsResponseStreaming || this.loaderShow || this.isProcessing || !!this.streamingSubscription;
  }

  private updateCurrentSessionId(): void {
    this.currentSessionId = this.chatSessionList.filter((item: { is_selected: boolean; }) => item.is_selected);
  }

  /**
   * Shows save error confirmation popup for new sessions
   * @param errorMessage - The error message to display
   */
  private displaySaveErrorConfirmationPopup(errorMessage: string): void {
    this.saveErrorMessage = errorMessage;
    this.showSaveErrorConfirmationPopup = true;
  }

  /**
   * Handles OK click in save error popup - redirects to new topic
   */
  confirmSaveErrorAndRedirect(): void {
    this.showSaveErrorConfirmationPopup = false;
    this.saveErrorMessage = "";
    
    // Remove the failed single question session before redirecting
    this.removeCurrentSessionIfSingleQuestion();
    
    // Redirect to new topic
    this.isAutoSessionCreation = true;
    this.ClickNewChat(true);
    this.isAutoSessionCreation = false;
  }

  /**
   * Shows the share conversation popup with the given data
   * @param shareData - Share link data from child component
   */
  onShowSharePopup(shareData: any): void {
    this.sharePopupData = shareData;
  }

  /**
   * Hides the share conversation popup
   */
  onHideSharePopup(): void {
    this.sharePopupData = null;
  }

  /**
   * Copies the share conversation link to clipboard
   */
  copyShareConversationLink(): void {
    if (!this.sharePopupData || !this.sharePopupData.share_link) return;
    
    navigator.clipboard.writeText(this.sharePopupData.share_link).then(() => {
      this.linkCopied = true;

      setTimeout(() => {
        this.linkCopied = false;
      }, 2000);
      this.showShareSuccessMessage();
      
      // Close the share popup after successful copy
      this.closeShareConversationPopup();
    }).catch(err => {
      this.loggerService.logError(this.ChatbotComponentError(err), 'copyShareLink');
    });
  }

  /**
   * Closes the share conversation popup
   */
  closeShareConversationPopup(): void {
    this.sharePopupData = null;
  }


  // Add a method to stop streaming
  public stopStreaming(): void {
    // Unsubscribe from main chat streaming
    if (this.streamingSubscription) {
        this.streamingSubscription.unsubscribe();
        this.streamingSubscription = null;
    }
    
    // Unsubscribe from news streaming
    if (this.newsStreamingSubscription) {
        this.newsStreamingSubscription.unsubscribe();
        this.newsStreamingSubscription = null;
    }
    
    // Close both WebSocket connections
    if (this.chatbotService.AllWebSocketsConnectionsOpen() || this.chatbotService.isWebSocketOpen() || this.chatbotService.isNewsWebSocketOpen() || this.chatbotService.isFileStatusTrackerWebSocketOpen()) {
      this.chatbotService.closeAllWebSockets();
    }
    // Reset all relevant state flags
    this.isProcessing = false; // Allow new requests
    this.IsResponseStreaming = false; // Indicate streaming has stopped
    this.IsLoader = false; // Reset loader flag for metadata spinner
    this.loaderShow = false; // Hide the general loader
    this.displayStopStreaming = false; // Hide the stop streaming button
    this.isOptionsEnable = true; // Re-enable icons/buttons
    this.followUpQuestions = []; // Clear follow-up questions
    this.followUpQuestionsShow = false; // Hide follow-up questions section
    this.note = false; // Reset any note display

    // Ensure the textarea is reset and adjusted
    this.txtChat = "";
    if (this.autoResizeDirective) {
        this.autoResizeDirective.resetHeight();
    }

    // Stop response loading state for current chat item when streaming is manually stopped
    const chatIndex = this.ChatQueriesList.length - 1;
    if (chatIndex >= 0) {
      this.responseLoadingStates[chatIndex] = false;
      this.newsLoadingStates[chatIndex] = false; // Also stop news loading if active
      delete this.newsErrorStates[chatIndex]; // Clean up any error states
      delete this.pendingNewsWebSocketSave[chatIndex]; // Clean up any pending news save requests
      delete this.websocketCompleteAndDataSaved[chatIndex]; // Clean up websocket complete state
    }

    // Force UI update
    this.cdr.detectChanges(); // Trigger change detection to update the UI
}

  /* istanbul ignore next */
  SendRequest(isUpdateQuestion: boolean): void {
    // Stop voice input if it's currently active
    if (this.voiceInputComponent && this.voiceInputComponent.isListening) {
      this.voiceInputComponent.stopListening();
    }
    this.micActive = false;
    
    if (this.isProcessing || this.loaderShow) {
      return; // Block new requests if one is already processing
    }
    this.isProcessing = true;
    try {
      this.CallSendRequest(isUpdateQuestion);
    } catch (error: any) {
      
      const log_error_message = this.translate.instant('SEND_REQUEST_ERR_MSG') +
        (error.message + " | " + error.stack)
      const translatedApologyMsg = this.translate.instant('APOLOGY_MESSAGE_DEFAULT');
      this.showCustomErrorMessage("saveChatResponse",
        translatedApologyMsg,
        log_error_message
      );
      this.isProcessing = false;
    }
  }

  handleError(context: string, error: any): void {
    this.hideLoader();
    this.isProcessing = true;
    if (error == 309) {
      const log_error_message = this.translate.instant('INTERNET_CONNECTION_LOST_ERR_MSG')+
        (typeof error === 'object' ? error.message + " | " + error.stack : "Status Code : " + error.toString())
      this.showPopupMessage({
        functionname: "HealthCheck",
        errorMessage: this.translate.instant('INTERNET_CONNECTION_LOST_ERR_MSG'),
        error: log_error_message
      });
    }
    else {
      const log_error_message = `${context}. Please contact support team If issue persist`+
        (typeof error === 'object' ? error.message + " | " + error.stack : "Status Code : " + error.toString())
      const translatedApologyMsg = this.translate.instant('APOLOGY_MESSAGE_DEFAULT');
      this.showPopupMessage({
        functionname: "HealthCheck",
        errorMessage: translatedApologyMsg,
        error: log_error_message
      });
    }
  }
  isValidJson(jsonString: string): boolean {
    try {
      JSON.parse(jsonString);
      return true;
    } catch (e) {
      return false;
    }
  }
  
  getDomainMapping(domainId: number) {
    const domainMappings: { [key: number]: string[] } = {
      1: ["MPR"], // Medical Products - 医薬哝 - 蝯哝
      2: ["COS"], // Cosmetics - 化粧哝 - 化妆哝
      3: ["MDV"], // Medical Devices - 医療機器 - 医疗器械
      4: ["CHP"], // Chemicals and Household Products - 化学製哝・家庭用哝 - 化学哝和家用产哝
      5: ["FDS"], // Food and Food Supplements - 食哝・栄養補助食哝 - 食哝和膳食补充剂
    };
      return domainMappings[domainId] || [];
  }

  /**
   * Get full domain name based on domain code using translations
   */
  getDomainFullName(domainCode: string): string {
    // Fallback to hardcoded names if translation not found
    const names: { [key: string]: string } = {
      'MPR': 'Medicinal Products',
      'COS': 'Cosmetics',
      'MDV': 'Medical Devices', 
      'CHP': 'Chemicals and Household Products',
      'FDS': 'Food and Food Supplements',
    };
    return names[domainCode.toUpperCase()] || domainCode;
  }
  /* istanbul ignore next */
  CallSendRequest(isUpdateQuestion: boolean): void {
    try {
      this.resetScrollState();
      let present_question = this.txtChat;
      this.txtChat = "";

      // Reset textarea height after clearing text
      setTimeout(() => {
        if (this.autoResizeDirective) {
          this.autoResizeDirective.resetHeight();
        }
      }, 10);

      if (isUpdateQuestion) {
        present_question = this.updateQuestion;
      }
      else {
        this.prompt = 'default';
        present_question = present_question?.trim();
        if (present_question === undefined || present_question === null || present_question === "") {
          this.hideLoader();
            this.isProcessing = false;
            return;
        }
      }
      this.followUpQuestions = [];
      this.followUpQuestionsShow = false;
      this.sessionIdArray = [];
      this.note = false;

      this.showLoader();
      this.defaultChat = true;
      let sessionId;
      this.updateCurrentSessionId();
      if (!this.currentSessionId?.length) {
        // Set flag to indicate this is automatic session creation
        this.isAutoSessionCreation = true;
        this.ClickNewChat(true);
        this.isAutoSessionCreation = false;
      }
      else {
        const chatHistoryCount = this.chatSessionList.length;
        if (chatHistoryCount > 30) {
          this.chatSessionList.pop();
        }
      }

      if (this.currentSessionId == null || this.currentSessionId.length == 0) {
        this.chatSessionList[0].is_selected = true;
        this.currentSessionId.push(this.chatSessionList[0]);
        this.currentSessionId[0].chat_name = this.getOptimizedName(present_question);
        this.currentSessionId[0].module_name = this.configdata.DisplayName;
      }

      this.IsNewChat = false;
      this.loginId = this.UserID;
      if (!this.currentSessionId[0].is_available || (this.currentSessionId[0].is_available && this.currentSessionId[0].chat_name == "New Topic")) {
        this.chatSessionList[0].chat_name = this.getOptimizedName(present_question);
        this.chatSessionList[0].module_name = this.configdata.DisplayName;
        this.ConversationHistoryCount = this.getConversationHistoryCount();
      }


      this.sessionIdArray.push(this.currentSessionId[0].session_id);

      const actualModuleName = this.configdata && this.configdata.actual_module_name ? this.configdata.actual_module_name : '';
      let getOldDomainId;
      if(!this.isDomainManagementEnabled){
        getOldDomainId = this.getDomainMapping(this.DomainID);
      }
    
      this.data = {
        Question: present_question,
        DomineModuleName: this.configdata.api_module_name ? this.configdata.api_module_name : (this.configdata.module_Name == undefined || this.configdata.module_Name == null) ? "" : this.configdata.module_Name,
        ModuleName: this.configdata.module_name,
        UserId: this.UserID,
        SessionId: this.sessionIdArray,
        ChatSessionName: this.currentSessionId[0].chat_name,
        DomainId: this.DomainID,
        prompt: this.prompt,
        ChatHistory: this.ChatQueriesList.map((item: { question: any; answer: any; }) => ({ Q: item.question, A: item.answer })).slice(0, 20),
        DataPrivileges: this.userDataPrivileges.length > 0 ? this.userDataPrivileges : [],
        Markets: this.Markets.length > 0 ? this.Markets : (this.configdata.MarketsPayloadRequired ? this.configdata.Countries : []),
        tenantID: this.configdata.default_tenant_id,
        streamResponseURL: this.streamResponseURL,
        ter: this.xApiKey,
        ModuleDisplayName: this.configdata.DisplayName,
        SubModuleName: this.configdata.actual_module_Name || '',
        SessionModuleName: this.currentSessionId[0].ModuleDisplayName,
        Privileges: this.Privileges,
        DomainName: environment.DomainName,
        selected_domains: this.isDomainManagementEnabled ? this.getSelectedDomains() : [environment.DomainName],
        available_domains: this.isDomainManagementEnabled ? this.getAvailableDomains() : [environment.DomainName],
        Access_Token: this.tokenService.getAccessToken()
      }

      if (this.showRetrievalModeToggle) {
        (this.data as any).retrieval_mode = this.retrievalModePreference.getRetrievalMode();
      }

      if (this.configdata.IsStreamingEnabled) {
        let loop = 0;
        let metadata: any[] = [];
        let visualizationData: any[] = []; // Change to array to accumulate multiple charts
        let preValue = "";
        let followUpQuestions: any[] = [];
        let full_response = "";
        // Capture attached files before clearing (only if file upload is enabled)
        const attachedFiles = this.isFileUploadEnabled && this.fileUploadState.uploadedFiles.length > 0
          ? this.fileUploadState.uploadedFiles.map(file => {
              const fileKey = `${file.name}_${file.size}`;
              const documentId = this.fileToDocumentIdMap.get(fileKey);
              return {
              name: file.name,
              size: file.size,
                type: file.type,
                documentId: documentId // Include documentId for preview
              };
            })
          : [];
        
        // Clear uploaded files from prompt area after capturing them
        if (this.isFileUploadEnabled && attachedFiles.length > 0) {
          this.fileUploadState.uploadedFiles = [];
          this.fileUploadState.ui.showFileCards = false;
          // Adjust textarea height after clearing files
          setTimeout(() => {
            if (this.autoResizeDirective) {
              this.autoResizeDirective.adjustHeight();
            }
          }, 10);
        }
        
        this.ChatQueriesObj = {
          question: present_question, answer: "", LikeClassAdded: null, disLikeClassAdded: null, LongText: null, RegenerateText: null,
          sessionid: null, ShotText: null, Comments: "", pk_chathistoryid: 0,news_feeds_id: null, metadata: [],isSpeaking: false,
          isPaused: false,utterance: null, image_visualization : "",visualizationData: [], newsAndUpdates: [],
          attachedFiles: attachedFiles, // Store attached files with the message
          ...(this.showRetrievalModeToggle ? { retrieval_mode: this.retrievalModePreference.getRetrievalMode() } : {})
        };
        this.ChatQueriesList?.push(this.ChatQueriesObj);
        
        // Store reference to current object to prevent race conditions
        const currentChatObject = this.ChatQueriesObj;
        this.isOptionsEnable = false;
        try {
          // Modify the subscription logic to use the streamingSubscription property
          this.streamingSubscription = this.chatbotService.callChunkedApiV2(this.data).subscribe({
            next: (jsonData: any) => {
              try {
                // Use consistent object reference to prevent race conditions
                const latestObject = currentChatObject;
                present_question = "";

                if (!latestObject) {
                  this.stopStreaming(); // Stop the streaming if the object is missing
                  return;
              }
              
                if (this.IsFirstTime) {
                  this.IsFirstTime = false;
                }

                this.IsResponseStreaming = true;


                if(jsonData.type == "start"){
                  this.followUpQuestions = [];
                  this.followUpQuestionsShow = false;
                  latestObject.followUpQuestions = [];
                  latestObject.metadata = [];
                  latestObject.visualizationData = []; // Reset as empty array
                  latestObject.image_visualization = "";
                  // Set response loading state for this specific chat item
                  const chatIndex = this.ChatQueriesList.length - 1;
                  this.responseLoadingStates[chatIndex] = true;
                  this.cdr.detectChanges();
                }
                else if (jsonData.type == "streaming") {
                  this.showEngagingLoader = false; // Switch to dot loader once streaming begins
                  this.displayStopStreaming = true;
                  latestObject.answer += jsonData.value;
                  this.autoScrollDuringStreaming();
                  // Trigger change detection to ensure the streaming dots appear
                  this.cdr.detectChanges();
                } 
                else if (jsonData.type === "image_visualization") {
                  // Handle visualization data from streaming response
                  if (jsonData.value) {
                    // Also add to the latest object for real-time display
                      latestObject.image_visualization += ` ${jsonData.value} `;
                    // Trigger change detection immediately
                    setTimeout(() => {
                      this.cdr.detectChanges();
                    }, 0);
                  }
                }
                else if (jsonData.type === "visualization") {
                  // Handle visualization data from streaming response
                  if (jsonData.value) {
                    const newChart = jsonData.value;
                    // Also add to the latest object for real-time display
                    if (!latestObject.visualizationData) {
                      latestObject.visualizationData = [];
                    }
                    latestObject.visualizationData.push(newChart);
                    // Trigger change detection immediately
                    setTimeout(() => {
                      this.cdr.detectChanges();
                    }, 0);
                  }
                } else if ((jsonData.type === "error" || jsonData.type == "single_response") && this.IsResponseStreaming) {
                  this.IsResponseStreaming = false;
                  this.isProcessing = false;
                  
                  // Hide confirmation popup if it's showing since response completed/errored
                  if (this.showNewChatConfirmationPopup) {
                    this.showNewChatConfirmationPopup = false;
                    this.pendingNewChatSession = false;
                  }
                  
                  if (this.autoResizeDirective) {
                    this.autoResizeDirective.resetHeight();
                  }
                  latestObject.answer = jsonData.value;
                  this.autoScrollDuringStreaming();
                  this.chatbotService.sendWebSocketMessage();
                  this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_available: true }));
                } else if (jsonData.type === "IsInternet" && this.IsResponseStreaming) {
                  this.note = !!jsonData.value;
                }
                else if (jsonData.type === "metadata_start") {
                  // Turn on metadata spinner in header
                  this.IsLoader = true;
                }
                else if (jsonData.type === "metadata") {
                  // Turn on metadata spinner in header when metadata streaming starts
                  this.IsLoader = true;
                  
                  // Handle metadata without start/complete events
                  if (jsonData.value && Object.keys(jsonData.value).length > 0) {
                    
                    // Initialize metadata array if not already done
                    if (!latestObject.metadata || !Array.isArray(latestObject.metadata)) {
                      latestObject.metadata = [];
                    }
                    
                    // Process new unified metadata structure
                    // jsonData.value should have structure: {"1": {id: "...", module_name: "...", metadata: {...}}}
                    Object.keys(jsonData.value).forEach(key => {
                      const metadataItem = jsonData.value[key];
                      if (metadataItem && typeof metadataItem === 'object') {
                        // Ensure the item has required properties and add key for backward compatibility
                        const processedItem = {
                          key: key,
                          ...metadataItem
                        };
                        latestObject.metadata.push(processedItem);
                      }
                    });
                    
                    // Trigger immediate UI update for dynamic rendering
                    setTimeout(() => {
                      this.cdr.detectChanges();
                    }, 0);
                  }
                }

                else if (jsonData.type === "metadata_complete") {
                  // Turn off metadata spinner in header
                  this.IsLoader = false;
                }
                else if (jsonData.type == "follow_up_q") {
                  this.followUpQuestions = [];
                  this.followUpQuestionsShow = false;
                  if (jsonData.value != undefined && jsonData.value.length > 0) {
                      this.followUpQuestionsShow = true;
                      this.followUpQuestions = jsonData.value;
                      latestObject.followUpQuestions = [jsonData.value];
                      if (!this.userHasScrolledUp && this.isNearBottom) {
                        setTimeout(() => {
                          this.executeScroll({ type: 'smooth', target: 'bottom' });
                        }, 200);
                      }
                  }
                } 
                
                else if (jsonData.type == "response_done" && this.IsResponseStreaming) {
                  this.isOptionsEnable = true;
                  this.isProcessing = false;
                  
                  const chatIndex = this.ChatQueriesList.length - 1;
                  this.responseLoadingStates[chatIndex] = false;
                  
                  
                  this.cdr.detectChanges();
                  
                  // Ensure we stay at bottom after streaming completes
                  if (!this.userHasScrolledUp && this.isNearBottom) {
                    setTimeout(() => {
                      this.executeScroll({ type: 'smooth', target: 'bottom' });
                    }, 100);
                  }
                  
                  this.chatbotService.sendWebSocketMessage();
                }
                else if (jsonData.conversation_saved == true) {
                  const timestamp = jsonData?.timestamp;
                  this.IsResponseStreaming = false;
                  this.displayStopStreaming = false;
                  // conversation_saved event - this is now optional since we save directly on response_done
                  
                  // Hide confirmation popup if it's showing since response is now complete
                  if (this.showNewChatConfirmationPopup) {
                    this.showNewChatConfirmationPopup = false;
                    this.pendingNewChatSession = false;
                  }

                  this.handleConversationSaved(jsonData, latestObject);
                  
                  // Handle news and updates if needed
                  if(this.isNewsAndFeedsEnabled){
                    const chatIndex = this.ChatQueriesList.length - 1;
                    if (latestObject.newsAndUpdates && latestObject.newsAndUpdates.length > 0) {
                      // Check if news is still loading
                      if (this.newsLoadingStates[chatIndex] === true) {
                        // Store the save request to be executed when news completes
                        this.pendingNewsWebSocketSave[chatIndex] = {
                          pk_chat_history_id: latestObject.pk_chathistoryid || jsonData.pk_chat_history_id,
                          fk_chatbotid: jsonData.fk_chatbotid,
                          newsAndUpdates: latestObject.newsAndUpdates
                        };
                      } else {
                        this.chatbotService.sendNewsWebSocketMessage(latestObject.pk_chathistoryid, jsonData.fk_chatbotid, latestObject.newsAndUpdates);
                      }
                    } else {
                      // No news updates to save, mark websocket as complete and data as saved
                      this.websocketCompleteAndDataSaved[chatIndex] = true;
                      this.cdr.detectChanges();
                    }
                  }
                  
                  this.updateUIAfterResponse(latestObject, timestamp);
                }
              }
              catch (error: any) {
                this.handleChatStreamError(error, 'processing chat response');
              }
            },
            error: (error: any) => {
              this.handleChatStreamError(error, 'WebSocket connection');
            },
            complete: () => {
              this.hideLoader();
              this.displayStopStreaming = false;
              this.isProcessing = false;
              this.IsResponseStreaming = false; // Ensure streaming flag is reset on completion
              
              // Hide confirmation popup if it's showing since response is complete
              if (this.showNewChatConfirmationPopup) {
                this.showNewChatConfirmationPopup = false;
                this.pendingNewChatSession = false;
              }
              
              // Clean up subscription reference when stream completes
              this.streamingSubscription = null;
            }
          });
          if(this.isNewsAndFeedsEnabled){
            this.newsStreamingSubscription = this.chatbotService.callNewsUpdatesWebSocket(this.data).subscribe({
              next: (newsData: any) => {
                try {
                  // Use consistent object reference to prevent race conditions
                  const latestObject = currentChatObject;
                  if (!latestObject) {
                    return;
                  }
                  if (!newsData || !newsData.type) {
                    return;
                  }
                  
                  if (newsData.type === "news_and_updates_start") {
                    // Initialize news array for the latest object
                    if (!latestObject.newsAndUpdates) {
                      latestObject.newsAndUpdates = [];
                    }
                    // Set loading state for this specific chat item
                    const chatIndex = this.ChatQueriesList.length - 1;
                    this.newsLoadingStates[chatIndex] = true;
                    // Clear any previous error state when starting fresh
                    delete this.newsErrorStates[chatIndex];
                    this.cdr.detectChanges();
                  }
                  else if (newsData.type === "error") {
                    this.handleNewsError(newsData.value, 'News WebSocket connection');
                  }
                  else if (newsData.type === "news_and_updates") {
                    // Handle news and updates data
                    if (newsData.value && Object.keys(newsData.value).length > 0) {
                      if (!latestObject.newsAndUpdates) {
                        latestObject.newsAndUpdates = [];
                      }
                      latestObject.newsAndUpdates.push(newsData.value);
                      
                      // Trigger immediate UI update for dynamic rendering
                      setTimeout(() => {
                        this.cdr.detectChanges();
                      }, 0);
                    }
                  }
                  else if (newsData.type === "news_and_updates_complete") {
                    if(latestObject.newsAndUpdates.length == 0){
                      this.newsAndUpdatesnodata = true;
                    }
                    // News and updates processing is complete
                    const chatIndex = this.ChatQueriesList.length - 1;
                    this.newsLoadingStates[chatIndex] = false;
                    
                    // Clear any error state since news completed successfully
                    delete this.newsErrorStates[chatIndex];
                    
                    // Check if there's a pending news WebSocket save request for this chat
                    if (this.pendingNewsWebSocketSave[chatIndex]) {
                      const pendingRequest = this.pendingNewsWebSocketSave[chatIndex];
                      this.chatbotService.sendNewsWebSocketMessage(pendingRequest.pk_chat_history_id, pendingRequest.fk_chatbotid, pendingRequest.newsAndUpdates);
                      // Clean up the pending request
                      delete this.pendingNewsWebSocketSave[chatIndex];
                    }
                    
                    this.cdr.detectChanges();
                  }
                  else if (newsData.type === "news_and_updates_saved") {
                    latestObject.news_feeds_id = newsData.value.news_feeds_id;
                    
                    // Mark websocket as complete and data as saved
                    const chatIndex = this.ChatQueriesList.length - 1;
                    this.websocketCompleteAndDataSaved[chatIndex] = true;
                    this.cdr.detectChanges();
                  }
                  
                } catch (error: any) {
                  this.loggerService.logError(this.ChatbotComponentError(error), 'processNewsData');
                  this.handleNewsError(error, 'Processing news data');
                }
              },
              error: (error: any) => {
                this.loggerService.logError(this.ChatbotComponentError(error), 'newsWebSocket');
                this.handleNewsError(error, 'News WebSocket connection');
              },
              complete: () => {
              }
            });
         }          
        }
        catch (error: any) {
          this.handleChatStreamError(error, 'sending chat request');
        }
      }
    } catch (error: any) {
      this.handleChatStreamError(error, 'sending chat request');
    }
  }


private updateUIAfterResponse(latestObject: any, timestamp: any):void{
  this.IsFirstTime = false;
  this.IsNewChat = false;
  this.txtChat = "";
  // Use conditional scroll that respects user's scroll position
  this.scrollToBottomIfAllowed();
  if (this.autoResizeDirective) {
    this.autoResizeDirective.resetHeight();
  }

  if (latestObject) {
  // Ensure proper UTC format
  const utcTimestamp = timestamp.endsWith("Z") ? timestamp : timestamp + "Z";
  latestObject.modified_date = this.format_date_time(utcTimestamp); 
  }

  this.isOptionsEnable = true;
  this.isProcessing = false;
  this.hideLoader();
  
  // Update markdown links after response is updated
  setTimeout(() => {
    this.updateMarkdownLinks();
  }, 100);
}



private handleChatStreamError(error: any, context: string): void{
  this.hideLoader();
    this.displayStopStreaming = false;
    
    // Hide confirmation popup if it's showing since response errored/stopped
    if (this.showNewChatConfirmationPopup) {
      this.showNewChatConfirmationPopup = false;
      this.pendingNewChatSession = false;
    }
    
    const latestObject = this.ChatQueriesList[this.ChatQueriesList.length - 1];
    const translatedApologyMsg = this.translate.instant('APOLOGY_MESSAGE_DEFAULT');
    if (latestObject) {
      latestObject.answer = translatedApologyMsg;
      latestObject.metadata = {};
    }

    this.isOptionsEnable = true;
    this.isProcessing = false;
    setTimeout(() => this.scrollToBottomSmooth(), 0);
    this.IsFirstTime = false;
    this.IsNewChat = false;
    this.txtChat = "";
    this.followUpQuestions = [];
    this.followUpQuestionsShow = false;
    this.note = false;

    const log_error_message = `Error in ${context}: ${error.message}.`;
    this.loggerService.logError(log_error_message, 'handleChatStreamError');
    this.showCustomErrorMessage("Chatstream", translatedApologyMsg, log_error_message);
}

  get_current_chat_datetime() {
    const utcDate = new Date().toISOString();
    // Create a Date object from the UTC date string
    const now = new Date();
    // Format each component to ensure the correct format
    const year = now.getUTCFullYear();
    const month = (now.getUTCMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = now.getUTCDate().toString().padStart(2, '0');
    const hours = now.getUTCHours().toString().padStart(2, '0');
    const minutes = now.getUTCMinutes().toString().padStart(2, '0');
    const seconds = now.getUTCSeconds().toString().padStart(2, '0');
    const milliseconds = now.getUTCMilliseconds().toString().padStart(3, '0');

    // Add fractional seconds up to six digits
    const microseconds = `${milliseconds}000`.slice(0, 6);

    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${microseconds}`;
    const dateObject = new Date(formattedDate);
    return dateObject;
  }

  /* istanbul ignore next */
  updateSessionChatHistory(latestObject: any, chatSessionName: any, module_name: any): void {
    this.data = {
      SessionId: this.sessionIdArray,
      SessionChatHistory: window.btoa(unescape(encodeURIComponent(localStorage.getItem('SessionChatHistory') ?? ''))),
    };
    this.data = {
      Question: latestObject.question,
      UserId: this.UserID,
      SessionId: this.sessionIdArray,
      ChatSessionName: chatSessionName,
      DomainId: this.DomainID,
      prompt: this.prompt,
      ChatHistory: this.ChatQueriesList.length == 1 ? [] : this.ChatQueriesList.map((item: { question: any; answer: any; }) => ({ Q: item.question, A: item.answer })).slice(0, 20),
      tenantID: this.tenantID,
      Answer: window.btoa(unescape(encodeURIComponent(latestObject.answer))),
      ModuleDisplayName: this.configdata.DisplayName.replace(/^@/, ''),
      SubModuleName: this.configdata.actual_module_Name || '',
      SessionModuleName: module_name, //this.currentSessionId[0].ModuleDisplayName
    };

    this.chatbotService.CallUpdateSessionChatHistory(this.data).subscribe((response: any) => {
      if (response.status == "200") {
      }
    });
  }


  extractChatSessionName(chatName: string): string {
    return chatName;
  }

  /* istanbul ignore next */
  convertArrayToObject(array: any[]): any {
    // Convert array to object with keys as string indices
    // This matches the expected backend format
    const obj: any = {};
    array.forEach((item, index) => {
      obj[(index + 1).toString()] = item;
    });
    return obj;
  }
  /* istanbul ignore next */
  saveChatResponseAndUpdateUI(latestObject: any, full_response: any, chatSessionName: string, module_name: string): void {
    this.data = {
      user_id: this.UserID,
      tenant_id: this.tenantID,
      thread_id: this.sessionIdArray[0],
      selected_domains: this.DomainID == 1 ? ["MPR"] : [],
      question: latestObject.question,
      answer: {
        text: latestObject.answer,
        image_Visualization: []
      },
      modules : [this.configdata.DisplayName.replace(/^@/, '')],
      source_metadata: {
        references: this.convertArrayToObject(latestObject.metadata || []),
        follow_up_questions: latestObject.followUpQuestions[0],
      }
    }
    this.chatbotService.saveChatResponse(this.data).subscribe((data) => {
      if (data.status.toString() == "200") {
        this.hideLoader();
        this.isOptionsEnable = true;
        let pk_chathistoryid = 0;
        if (data.body?.data?.response_id) {
          // New structure: response_id is directly in data object
          pk_chathistoryid = data.body.data.response_id;
        } else if (data.body?.data?.pk_chat_history_id) {
          // Fallback for old structure
          pk_chathistoryid = data.body.data.pk_chat_history_id;
        } else if (Array.isArray(data.body?.data)) {
          // Fallback for array structure
          data.body.data.forEach((item: any) => {
            pk_chathistoryid = item.pk_chat_history_id || item.response_id;
          });
        }
        latestObject.pk_chathistoryid = pk_chathistoryid;
        this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_available: true }));

        // Update counts after successful save - increment count for current module
        this.incrementCountAfterSuccessfulSave();
      } else if (data.status.toString() == "309") {
        this.handleError(this.translate.instant('INTERNET_CONNECTION_LOST_ERR_MSG'), data.status.toString());
      }
      else {
        this.hideLoader();
        let pk_chathistoryid = 0;
        data.body?.data?.forEach((item: any) => {
          pk_chathistoryid = item.pk_chat_history_id;
        });

        if (latestObject.pk_chathistoryid == 0) {
          latestObject.pk_chathistoryid = pk_chathistoryid;
        } else {
          this.ChatQueriesObj = {
            question: this.txtChat, answer: "", LikeClassAdded: null, disLikeClassAdded: null, LongText: null, RegenerateText: null,
            sessionid: null, ShotText: null, Comments: "", pk_chathistoryid: 0, metadata: [], attachedFiles: []
          };
          this.ChatQueriesList?.push(this.ChatQueriesObj);
        }
        if (data.status.toString() !== "407") {
          const translatedApologyMsg = this.translate.instant('APOLOGY_MESSAGE_DEFAULT');
          this.CustomErrorMessageText = translatedApologyMsg;
        }

        this.chatSessionList = this.chatSessionList.map((item: any) => ({ ...item, is_available: true }));
        this.IsFirstTime = false;
        this.IsNewChat = false;
        this.txtChat = "";
        this.followUpQuestions = [];
        this.followUpQuestionsShow = false;
        this.note = false;
        this.isOptionsEnable = true;
        const log_error_message = (data.error_message + (data.error ?? "Unknown error occurred while saving chat response"))
        this.loggerService.logError(log_error_message, 'saveChatResponseAndUpdateUI');
        const translatedApologyMsg = this.translate.instant('APOLOGY_MESSAGE_DEFAULT');
        this.showCustomErrorMessage("saveChatResponse",
          translatedApologyMsg, log_error_message);
      }
    });
  }

  showCustomErrorMessage(functionname: string,errorMessage: string, error: string): void {
    const latestObject = this.ChatQueriesList[this.ChatQueriesList?.length - 1];
      if (latestObject) {
          latestObject.answer = errorMessage;
          latestObject.metadata = [];
        }
  }

  showPopupMessage(event: PopupMessageEvent):void {
    this.IsCustomErrorMessageVisible = true;
    this.CustomErrorMessageText = event.errorMessage ?? this.translate.instant('CONTACT_SUPPORT_ERR_MSG');;
    setTimeout(() => {
      this.IsCustomErrorMessageVisible = false;
      this.CustomErrorMessageText = "";
    }, 15000);
  }

  handleNewsError(error: any, context: string): void {
    const chatIndex = this.ChatQueriesList.length - 1;
    if (chatIndex < 0) return;

    // Reset loading state
    this.newsLoadingStates[chatIndex] = false;
    
    // Clean up any pending save requests
    if (this.pendingNewsWebSocketSave[chatIndex]) {
      delete this.pendingNewsWebSocketSave[chatIndex];
    }
    
    // Reset websocket completion state on error
    delete this.websocketCompleteAndDataSaved[chatIndex];

    // Determine error message based on context and error type
    let errorMessage = '';
    
    if (!navigator.onLine) {
      errorMessage = this.translate.instant('INTERNET_CONNECTION_LOST_ERR_MSG');
    } else if (error && error.message) {
      if (error.message.includes('timeout')) {
        errorMessage = 'News loading timed out. Please check your connection.';
      } else if (error.message.includes('auth') || error.message.includes('401')) {
        errorMessage = 'Authentication failed while loading news.';
      } else if (error.message.includes('network') || error.message.includes('connection')) {
        errorMessage = 'Network connection error. Unable to load news.';
      } else if (context.includes('Processing')) {
        errorMessage = 'Error processing news data.';
      } else {
        errorMessage = this.translate.instant('DS_API_FAILED_ERR_MSG');
      }
    } else {
      // Default error message
      errorMessage = this.translate.instant('DS_API_FAILED_ERR_MSG');
    }

    // Set the error message
    this.newsErrorStates[chatIndex] = errorMessage;
    
    // Log error for debugging
    const log_error_message = `Error in ${context}: ${error?.message || 'Unknown error'}`;
    this.loggerService.logError(log_error_message, 'handleNewsError');
    
    // Trigger UI update
    this.cdr.detectChanges();
  }

  getOptimizedName(question: string): string {
    return question;
  }


  FollowUpQuestionClick(fq: any) {
    if (this.isProcessing || this.loaderShow) {
      return;
    }
    // Enable scroll for the new question response that will be added
    this.isResponseScroll = true;
     this.scrollToBottomSmooth();
    this.updateQuestion = fq;
    this.prompt = 'default';
    this.SendRequest(true);
    this.audioCopies.forEach(audioCopy => audioCopy.stopSpeaking());
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.adjustHeight();
      }
    });
  }



  onSpanInput(event: any) { this.editText = event.target.textContent; }



  isAnyOptionChecked(options: any[]): boolean {
    return options.some(option => option.IsChecked);
  }

  async transformNewChatHistoryToOldFormat(newData: any[]): Promise<any[]> {
    return newData.map((item: any) => {
      // Parse the answer if it's a JSON string
      let parsedAnswer = item?.answer || '';
      let image_visualization = [];
      if (typeof item.answer === 'string') {
        try {
          const answerObj = JSON.parse(item.answer);
          parsedAnswer = answerObj.text || item?.answer || '';
          image_visualization = answerObj?.image_visualization || [];
        } catch (e) {
          // If parsing fails, use the original answer
          parsedAnswer = item?.answer || '';
          image_visualization = item?.image_visualization || [];
        }
      } else if (item.answer && typeof item.answer === 'object') {
        parsedAnswer = item.answer.text || '';
        image_visualization = item.answer.image_visualization || [];
      }

      const retrieval_mode = extractRetrievalModeFromHistoryAnswer(item.answer);
  
      // Extract follow-up questions from source_metadata
      const formattedFollowUpQuestions = item?.source_metadata?.follow_up_questions || [];
      
      // Create metadata object in old format
      const metadataObj = {
        follow_up_questions: formattedFollowUpQuestions,
        IsInternet: false,
        module_name: Array.isArray(item?.modules) && item.modules.length > 0 ? item.modules[0] : 'regulations',
        answer: {
          metadata: item?.source_metadata?.references || [],
          text: parsedAnswer,
          image_visualization: image_visualization,
        },
      };

      return {
        pk_chathistoryid: item?.response_id, // Using response_id as pk_chathistoryid
        //fk_chatbotid: 4747, // Default value, you might need to adjust
        sessionid: item?.thread_id || '', // This should come from the request context
        module_name: item?.modules[0] || '', //this.getModuleDisplayName(item.modules),
        chatname: item?.thread_name || '', // This should come from session context
        question: item?.question,
        answer: parsedAnswer,
        retrieval_mode,
        islike: item?.is_like,
        comments: item?.comments || '',
        feedback: item?.feedback || '',
        additionalcomments: '',
        metadata: JSON.stringify(metadataObj),
        modified_date: item?.created_at,
      };
    });
  }

  async GetChatHistory(SessionID: string[]): Promise<void> {
    this.isOptionsEnable = true;
    this.isResponseScroll = true;
    this.note = false;
    this.errorMsg = "";
    this.isLoading = true
    this.followUpQuestions = [];
    this.followUpQuestionsShow = false;
    this.SessionChatHistory = []
    this.data = {
      tenant_id: this.tenantID,
      thread_id: SessionID?.[0] || '',
    }
    if(!this.isDomainManagementEnabled){
      this.data = {
        ...this.data,
        selected_domains: [environment.DomainName],
      };
    }
    this.chatbotService.GetChatHistoryAPI(this.data)
      .subscribe({
        next: async (response: HttpResponse<any>) => {
          this.isLoading = false
          if (response.status === 200) {

            if (response.body.data !== null && response.body.data !== undefined && response.body.data.length > 0) {
              this.ChatQueriesList = [];
              this.SessionChatHistory = response.body.data[0].session_chat_history;
              localStorage.setItem('SessionChatHistory', response.body.data[0].session_chat_history);
              
              // Reset websocket states and news flags for historical data loading
              this.websocketCompleteAndDataSaved = {};
              this.newsLoadingStates = {};
              this.newsErrorStates = {};
              this.newsAndUpdatesnodata = false;
              const transformedData = await this.transformNewChatHistoryToOldFormat(response.body.data);
              transformedData.forEach((item: any, index: number) => {
                const Module_Name = item.module_name?.trim().toUpperCase();
                const Module_Info = Object.values(moduleDetails).find((module: any) =>
                  module.DisplayName.toUpperCase() === Module_Name
                ) as ModuleInfo;
                  if (Module_Info) {
                    const module_value = Object.keys(moduleDetails).find(key => (moduleDetails as any)[key] === Module_Info) || '';
                    let selected_value: any = {};
                    selected_value.type = 1;
                    selected_value.selectedVectorDbDataset = {
                      name: Module_Info.DisplayName,
                      value: module_value,
                      default: false
                    };
                    this.sharedService.changeSelectedValue(selected_value);
                    const updatedDataset = this.vectorDbDatasets.find(dataset => dataset.value === selected_value.selectedVectorDbDataset.value);
                    if (updatedDataset && this.selectedVectorDbDataset?.value !== updatedDataset.value) {
                      this.selectedVectorDbDataset = updatedDataset;
                      // Validate that selectedVectorDbDataset is not undefined/null/empty
                      this.ensureValidSelectedDataset();
                      // Update domains for the new dataset only if domain management is enabled (but don't await to avoid blocking chat history loading)
                      if (this.isDomainManagementEnabled) {
                        this.updateDomainsList().catch(error => this.loggerService.logError(this.ChatbotComponentError(error), 'getChatHistory'));
                      }
                    }
                  }
                  const feedbackArray = Array.isArray(item.feedback) ? item.feedback : (item.feedback && typeof item.feedback === 'string' ? JSON.parse(item.feedback) : []);
                  let dislike = null;
                  if (typeof item.islike === 'boolean') {
                    dislike = !item.islike;
                  }
                  else {
                    item.islike = null;
                  }
                  this.ChatQueriesObj = {
                    pk_chathistoryid: item.pk_chathistoryid, question: item.question, answer: item.answer,
                    LikeClassAdded: item.islike, disLikeClassAdded: dislike, longtext: item.longtext,
                    regeneratetext: item.regeneratetext, sessionid: item.sessionid, shottext: item.shottext, comments: item.comments,
                    chatname: item.chatname,
                    AdditionalComments: typeof item.additionalcomments === 'string' ? item.additionalcomments : '',
                    FeedbackArray: feedbackArray,
                    FeedbackOptions: this.configdata.FeedbackOptions.map((element: any) => {
                      return {
                        ...element,
                        IsChecked: feedbackArray.includes(element.Id) ? true : false,
                        pk_chathistoryid: item.pk_chathistoryid,
                      };
                    }),
                    metadata: this.parseOldChatMetadata(item.metadata),
                    followUpQuestions: this.extractFollowUpQuestions(item.metadata),
                    modified_date: this.format_date_time(item.modified_date),
                    isSpeaking: false,
                    isPaused: false,
                    utterance: null,
                    image_visualization : this.extractImageVisualization(item.metadata) || "",
                    visualizationData: this.extractVisualizationData(item.metadata),
                    news_feeds_id: item?.news_and_feeds?.news_and_feeds_id || null,
                    newsAndUpdates: item?.news_and_feeds?.news_and_feeds_data || [],
                    attachedFiles: item.attachedFiles || [], // Restore attached files from history
                    retrieval_mode: item.retrieval_mode
                  };
                  
                  // For historical news data, mark as complete and data saved since it's already from API
                  if (this.ChatQueriesObj.newsAndUpdates && this.ChatQueriesObj.newsAndUpdates.length > 0) {
                    this.websocketCompleteAndDataSaved[index] = true;
                    this.newsAndUpdatesnodata = false;
                  } else if (this.ChatQueriesObj.newsAndUpdates && this.ChatQueriesObj.newsAndUpdates.length === 0) {
                    this.websocketCompleteAndDataSaved[index] = true;
                    // Don't set newsAndUpdatesnodata to true here as other chat items might have news
                  }
                  
                  this.ChatQueriesList?.push(this.ChatQueriesObj);
                });
                this.ChatQueriesList = this.ChatQueriesList.reverse();
                this.FeedbackOptions = this.ChatQueriesObj.FeedbackOptions;
                
                // Check if any chat items have news data, if not, show no data message
                const hasAnyNews = this.ChatQueriesList.some((chat: any) => 
                  chat.newsAndUpdates && chat.newsAndUpdates.length > 0
                );
                if (!hasAnyNews) {
                  this.newsAndUpdatesnodata = true;
                }
                
                this.IsFirstTime = false;
                this.IsNewChat = false;
                this.questiontxt = "";
                this.followUpQuestionsShow = true;

                // Trigger change detection to ensure DOM is updated
                this.cdr.detectChanges();
                
                // Setup scroll detection if not already done
                if (!this.chatContainer) {
                  setTimeout(() => this.initializeScrollDetector(), 100);
                }
                
              } else {
                this.ChatQueriesList = [];
                this.IsFirstTime = false;
                this.IsNewChat = true;
              }
          }
        },
        error: (e) => { 
          this.hideLoader(); 
          this.isLoading = false;
        }
      });
  }

  // Helper method to extract follow-up questions from metadata supporting both structures
  extractFollowUpQuestions(metadata: string): any {
    if (!metadata) {
      return []; // Return empty array instead of empty object
    }

    try {
      const parsedMetadata = JSON.parse(metadata);
      
      // Handle both follow-up question structures
      if (parsedMetadata.follow_up_q && Array.isArray(parsedMetadata.follow_up_q)) {
        // Structure: follow_up_q with objects [{Question: "..."}, {Question: "..."}]
        const questions = parsedMetadata.follow_up_q.map((q: any) => q.Question);
        return [questions]; // Wrap in array to match original format
      } else if (parsedMetadata.follow_up_questions && Array.isArray(parsedMetadata.follow_up_questions)) {
        // Structure: follow_up_questions with direct strings ["question1", "question2"]
        return [parsedMetadata.follow_up_questions]; // Wrap in array to match original format
      }
      
      return []; // Return empty array instead of empty object
    } catch (e) {
      this.loggerService.logError(this.ChatbotComponentError(e), 'hasFollowUpQuestions');
      return []; // Return empty array instead of empty object
    }
  }

  extractImageVisualization(metadata: string): any {
    if (!metadata) return "";

    try {
      const parsedMetadata = JSON.parse(metadata);
      const images = parsedMetadata?.answer?.image_visualization;
      if (Array.isArray(images)) {
      // Collect all non-empty base64 strings and join with a space
      return images
        .map((item: any) => item?.png_base64?.trim())
        .filter((base64: string) => !!base64)
        .join(" ");
    }
    return "";
    } catch (e) {
      this.loggerService.logError(this.ChatbotComponentError(e), 'hasImageVisualization');
      return "";
    }
  }

  format_date_time(parsed_date: Date) {
    try{
    // Keep the date in UTC without timezone conversion
    const date = new Date(parsed_date);
  
    const day = date.getUTCDate().toString().padStart(2, '0'); // Use UTC date
    const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' }); // Use UTC month
    const year = date.getUTCFullYear(); // Use UTC year
    const hours = date.getUTCHours().toString().padStart(2, '0'); // Use UTC hours in 24-hour format
    const minutes = date.getUTCMinutes().toString().padStart(2, '0'); // Use UTC minutes
  
    const formattedDate = `${month} ${day}, ${year}, ${hours}:${minutes} UTC`;
    return formattedDate;
    } catch (e) {
      this.loggerService.logError(this.ChatbotComponentError(e), 'format_date_time');
      return "";
    }
  }  
  LikeDisLike(chatdata: any, ChatHistoryID: number, IsLike: boolean) {

    this.isResponseScroll = false;
    this.IsLikeSelected = !IsLike;
    if (IsLike) {
      chatdata.LikeClassAdded = false;
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);
      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, chatdata.LikeClassAdded, {}, "", isReset).subscribe((data) => {
        if (data.status === 200) {
            if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
          }
        }
      }, error => {
      })
    }
    else {
      this.isResponseScroll = false;
      chatdata.LikeClassAdded = true;
      chatdata.disLikeClassAdded = false;
      chatdata.SubmitFeedback = false;
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);
      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, chatdata.LikeClassAdded, {}, "", isReset).subscribe((data) => {
        if (data.status === 200) {
            if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
            }
        }
      }, error => {
      })
    }

  }

  /* istanbul ignore next */
  RegenerateActions(question: any, promptAction: any) {
    if (this.isProcessing) {
      return;
    }
      const promptKey = promptAction.toLowerCase();
      let enhancedQuestion: any;
      let selectedPrompt: string;
      if (promptKey === 'shorter') {
          selectedPrompt = 'crisp';
      } else if (promptKey === 'longer') {
          selectedPrompt = 'detailed';
      } else if (promptKey === 'regenerate') {
          selectedPrompt = 'regenerate';
      } else {
          selectedPrompt = ''; // Default case if none match
      }
      if(selectedPrompt != ''){
        const enhancedPrompt = this.chatbotService.enhancementPrompts[selectedPrompt] || ''; // Get the enhanced prompt or an empty string
        const phrasesToRemove = Object.values(this.chatbotService.enhancementPrompts).map(prompt => prompt.trim()).join('|');
        const cleanQuestion = question.replace(new RegExp(phrasesToRemove, 'gi'), '').trim();
        // Prepare the final question to send
        enhancedQuestion = enhancedPrompt ? `${enhancedPrompt} ${cleanQuestion}` : cleanQuestion;
        this.updateQuestion = enhancedQuestion;
      }
      else{
        this.updateQuestion = question;
      }
    this.prompt = promptAction;
    this.SendRequest(true);
  }

  handleCheckboxChange(item1: any) {
    if (item1.isChecked) {
      this.sessionIdClickArray.push(item1.sessionid);
    }
    else {
      const index: number = this.sessionIdClickArray.indexOf(item1.sessionid);
      if (index !== -1) {
        this.sessionIdClickArray.splice(index, 1);
      }
    }


  }

  PopularQuestionClick(question: string) {
    if (this.isProcessing || this.loaderShow) {
      return;
    }
    
    // Enable scroll for the new question response that will be added
    this.isResponseScroll = true;
    this.scrollToBottomSmooth();
    this.txtChat = question;
    this.prompt = 'default';
    this.SendRequest(false);
    this.audioCopies.forEach(audioCopy => audioCopy.stopSpeaking());
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.adjustHeight();
      }
    });
   
  }


  isMetadataNotEmpty(metadata: any): boolean {
    try {
      if (!metadata || !Array.isArray(metadata) || metadata.length === 0) {
        return false;
      }
      // Additional safety check for the first element
      if (!metadata[0] || typeof metadata[0] !== 'object') {
        return false;
      }
      return JSON.stringify(metadata[0]) !== '{}';
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'checkMetadata');
      return false;
    }
  }


  clearCheckboxes(chatdata: any) {

    this.isResponseScroll = false;
    if (chatdata.FeedbackOptions) {
      // Reset all IsChecked properties to false
      chatdata.FeedbackOptions.forEach((option: any) => {
        option.IsChecked = false;
      });
    }
    if (chatdata) {
      chatdata.AdditionalComments = "";
    }
    chatdata.disLikeClassAdded = false;
    chatdata.SubmitFeedback = false;
    chatdata.ErrorMsg = false;
  }
  Dislikesubmit(chatdata: any, ChatHistoryID: number, Dislike: boolean) {
    this.FeedbackCBDict = {};
    this.isResponseScroll = false;
    let count = 0;
    if (chatdata.FeedbackOptions) {
      chatdata.FeedbackOptions.forEach((FB: any, ind: any) => {
        if (FB.IsChecked) {
          count++;
        }
      });
    }
    if (count > 0) {
      chatdata.FeedbackOptions.forEach((subcat: any, ind: any) => {
        if (subcat.IsChecked) {
          this.FeedbackCBDict[subcat.Id] = subcat.Name;
        }
      });
      const jsonData = JSON.stringify(this.FeedbackCBDict);
      this.isResponseScroll = false;
      const comments = chatdata.AdditionalComments.length > 0 ? chatdata.AdditionalComments : " ";
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);

      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, Dislike, jsonData, comments, isReset).subscribe((data: any) => {

        if (data.status === "200") {
          if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
          }
        }
      }, error => {
      })
      chatdata.SubmitFeedback = false;
    }
    else {
      chatdata.ErrorMsg = true;
    }
  }
  DisLikeclick(chatdata: any, ChatHistoryID: number, DisLike: boolean) {

    this.isResponseScroll = false;
    if (this.configdata && Array.isArray(this.configdata.FeedbackOptions)) {
      chatdata.FeedbackOptions = this.configdata.FeedbackOptions.map((option: any) => ({
        ...option,
        pk_chathistoryid: chatdata.pk_chathistoryid
      }));
    } else {
      this.loggerService.logError(this.ChatbotComponentError('FeedbackOptions is not defined.'), 'DisLikeclick');
      chatdata.FeedbackOptions = [];
    }
    if (!chatdata.disLikeClassAdded) {
      chatdata.AdditionalComments = "";
      chatdata.disLikeClassAdded = true;
      chatdata.SubmitFeedback = true;
      chatdata.LikeClassAdded = false;
      chatdata.ErrorMsg = false;
    }
    else {
      chatdata.disLikeClassAdded = false;
      chatdata.SubmitFeedback = false;
      this.clearCheckboxes(chatdata);
      chatdata.AdditionalComments = "";
      let isReset = this.VerifyIsReset(chatdata.LikeClassAdded, chatdata.disLikeClassAdded);
      this.chatbotService.UpdateDisLikeFeedback(ChatHistoryID, DisLike, "", "", isReset,).subscribe((data) => {
        if (data.status === 200) {
          if (data.body.data !== null && data.body.data !== undefined && data.body.data.length > 0) {
          }
        }
      }, error => {
      })
    }
  }
  VerifyIsReset(islike: any, isdislike: any) {
    if (!islike && !isdislike) {
      return true;
    }
    return false;
  }
  DisplayChatHistory() {
    this.ShowChatHistory = !this.ShowChatHistory;
    this.closeSourcePanel();
    this.closeFilePreviewPanel();
  }

  DisableChatHistory() {
    this.ShowChatHistory = false;
  }

  DisplaySourcePanel(sourceData?: any) {
    // Close file preview if open
    this.closeFilePreviewPanel();
    
    this.isSourcePanelVisible = true;
    
    if (sourceData) {
      this.currentSourceData = sourceData;
    }
    
    // Force change detection to ensure UI updates
    this.cdr.detectChanges();
  }

  closeSourcePanel() {
    this.isSourcePanelVisible = false;
    this.currentSourceData = null;
  }

  isChatSessionListValid(): boolean {
    return this.chatSessionList.filter((item: any) => item.chat_name !== 'New Topic').length >= 0;
  }

  getConversationHistoryCount(): number {
    // Return the appropriate count based on selected tab
    if (this.selectedTab === 'All') {
      // Sum all module counts for "All" tab
      return Object.values(this.moduleThreadsCounts).reduce((sum, count) => sum + count, 0);
    } else {
      // Return module-specific count for individual tabs
      return this.moduleThreadsCounts[this.selectedTab.toLowerCase()] || 0;
    }
  }

  /**
   * Updates conversation history counts after a chat response is successfully saved
   * This increments the count for the current module only
   */
  incrementCountAfterSuccessfulSave(): void {
    try {
      // Check if this is truly a new thread by examining the session state
      // A session is "new" if it's unavailable or still has the default "New Topic" name
      const isNewThread = this.currentSessionId?.[0] && 
                         (!this.currentSessionId[0].is_available || 
                          this.currentSessionId[0].chat_name === "New Topic");
      
      // Only increment count for the first message in a new thread
      if (!isNewThread) {
        return;
      }

      // Get the current module name
      const currentModuleName = this.configdata?.DisplayName?.toLowerCase();

      if (currentModuleName) {
        // Increment the count for the current module by 1
        // Create a new object reference to trigger Angular change detection
        this.moduleThreadsCounts = {
          ...this.moduleThreadsCounts,
          [currentModuleName]: (this.moduleThreadsCounts[currentModuleName] || 0) + 1
        };

        // Update the overall conversation history count
        this.ConversationHistoryCount = this.getConversationHistoryCount();
        
        // Mark the session as available so subsequent messages don't increment the count
        if (this.currentSessionId[0]) {
          this.currentSessionId[0].is_available = true;
        }
        
        // Explicitly trigger change detection to update UI immediately
        this.cdr.detectChanges();
      }

    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), "incrementCountAfterSuccessfulSave");
    }
  }


  CancelShowRegulationMarketsWindow() {
    this.isResponseScroll = false;
    this.ShowRegulationMarketsWindow = false;
    this.RegulationId = "";
    this.RegulationMarkets = "";
    this.RegulationTitle = "";
  }


  CloseSuccessMessage() {
    this.isResponseScroll = false;
    this.DeleteSuccessMessage = false;
    this.EditSuccessMessage = false;
    this.ShareSuccessMessage = false;
    this.IsCustomErrorMessageVisible = false;
    this.CustomErrorMessageText = "";
  }

  showDeleteSuccessMessage() {
    this.DeleteSuccessMessage = true;
    setTimeout(() => {
      this.DeleteSuccessMessage = false;
    }, 4000)
  }

  showEditSuccessMessage() {
    this.EditSuccessMessage = true;
    setTimeout(() => {
      this.EditSuccessMessage = false;
    }, 4000)
  }

  showShareSuccessMessage() {
    this.ShareSuccessMessage = true;
    setTimeout(() => {
      this.ShareSuccessMessage = false;
    }, 4000)
  }

  onEnterPress(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.key === "Enter" && !this.loaderShow) {
        if (keyboardEvent.shiftKey) return; // No need to check key again

        // Check if IME composition is active - if so, don't process the Enter key
        const target = keyboardEvent.target as HTMLElement;
        if (target && target.hasAttribute('data-ime-composing')) {
            return; // Let IME handle the Enter key for selection
        }

        // Check if domain switch suggestions are visible, if yes let domain switch handle the event
        if (this.isDomainManagementEnabled && this.domainSwitchComponent && this.domainSwitchComponent.showSuggestions) {
            return; // Let domain switch component handle the Enter key
        }

        keyboardEvent.preventDefault();

        // Check if txtChat is defined and not null
        if (!this.txtChat || this.txtChat.trim() === "") return;

        this.SendRequest(false);
        setTimeout(() => {
            this.isProcessing = false;
            this.scrollToBottomSmooth();
        }, 1000);
    }
}
  
  OnPromptLibrary(){
    this.DisplayPromptLibrary = !this.DisplayPromptLibrary;
  }

  onShowSource (){
    this.DisplaySource = !this.DisplaySource
  }

  async onNewSelectedDataset(dataset: any) {
    // Check if the dataset is actually different
    if (this.selectedVectorDbDataset?.value === dataset?.value) {
      return;
    }

    this.selectedVectorDbDataset = dataset;
    // Ensure the dataset matches an item in vectorDbDatasets
    const matchingDataset = this.vectorDbDatasets.find(d => d.value === dataset.value);
    if (matchingDataset) {
      this.selectedVectorDbDataset = matchingDataset;
    }
    
    // Validate that selectedVectorDbDataset is not undefined/null/empty
    this.ensureValidSelectedDataset();
    
    if(this.isDomainManagementEnabled){
      // Update domains list when module changes
      await this.updateDomainsList();
    }
    // Trigger change detection if necessary
    this.cdr.detectChanges();
    this.resizeDropdownWidth();
  }

  onChatQueriesListEmit(data: any): void {
    this.ChatQueriesList.forEach((chat: any, index: any) => {
        if (data[index]) {
            chat.isSpeaking = data[index].isSpeaking; // Update isSpeaking
            chat.isPaused = data[index].isPaused;     // Update isPaused
        }
    });
}

  stopSpeaking(): void {
    this.audioCopies.forEach(audioCopy => audioCopy.stopSpeaking());
    this.ChatQueriesList.forEach((chat: any) => {
      chat.isSpeaking = false;
      chat.isPaused = false;
      chat.utterance = null;
    });
    this.cdr.detectChanges();
  }

  getGreetingMessage(): string {
  const greetingTemplate = this.translate.instant('GREETING_TEXT.HELLO_MESSAGE');
  return greetingTemplate.replace('{{UserFName}}', this.userFName);
}

  // Add a flag to prevent infinite loops
  private isUpdatingMarkdown = false;

  // Update markdown links after response is updated
  private updateMarkdownLinks(): void {
    // Prevent infinite loops
    if (this.isUpdatingMarkdown) {
      return;
    }
    
    this.isUpdatingMarkdown = true;
    
    try {
      // Find all markdown containers (both <markdown> elements and .markdown-content divs)
      const markdownElements = this.elementRef.nativeElement.querySelectorAll('markdown, .markdown-content');
      
      markdownElements.forEach((markdownEl: HTMLElement) => {
        // Check if this element has already been processed
      const isLastChatItem = this.isLastChatItemMarkdown(markdownEl);
      const shouldSkipProcessing = markdownEl.hasAttribute('data-processed') && 
                                   !this.IsResponseStreaming && 
                                   !isLastChatItem;
      if (shouldSkipProcessing) {
        return;
      }
        
        // First, handle text-based bullet points
        this.formatTextBasedLists(markdownEl);
        
        // Then handle external links
        const links = markdownEl.querySelectorAll('a[href]');
        links.forEach((link: any) => {
          const href = link.getAttribute('href');
          
          // Process ALL links to open in new tabs
          if (href && link.getAttribute('target') !== '_blank') {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
            
            // Add security attributes for external links
            if (href.startsWith('http://') || href.startsWith('https://')) {
              link.setAttribute('referrerpolicy', 'no-referrer');
            }
          }
        });
        
        // Mark as processed
        markdownEl.setAttribute('data-processed', 'true');
      });
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'updateMarkdownLinks');
    } finally {
      this.isUpdatingMarkdown = false;
    }
  }
  private isLastChatItemMarkdown(markdownEl: HTMLElement): boolean {
    // Check if the markdown element is within the last chat item container
    const lastDiv = markdownEl.closest('.lastDiv');
    return lastDiv !== null;
  }

    /**
   * Converts text-based bullet points to proper HTML structure
   * Now handles ngx-markdown processed content by merging separate UL elements
   */
  private formatTextBasedLists(container: HTMLElement): void {
    try {
      // Check if this container has already been processed for list formatting
      if (container.hasAttribute('data-lists-processed')) {
        return;
      }
      
      // First, handle the text-based formatting for paragraphs that haven't been processed by ngx-markdown
      this.formatParagraphLists(container);
      
      // Then, handle already processed UL elements that need to be nested
      this.mergeAdjacentLists(container);
      
      // Mark as processed to prevent reprocessing
      container.setAttribute('data-lists-processed', 'true');
      
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'formatTextBasedLists');
    }
  }

  /**
   * Handle text-based bullet points in paragraphs
   */
  private formatParagraphLists(container: HTMLElement): void {
    const paragraphs = container.querySelectorAll('p');
    
    paragraphs.forEach((p: HTMLElement) => {
      const text = p.innerHTML;
      
      // Check if paragraph contains bullet points
      if (text.includes('•') || text.includes('\n•')) {
        // Split the text by lines and process
        const lines = text.split('\n');
        let htmlContent = '';
        let inMainList = false;
        
        lines.forEach((line) => {
          const trimmedLine = line.trim();
          
          if (!trimmedLine) {
            return;
          }
          
          if (trimmedLine.startsWith('•')) {
            // Start main list if not already started
            if (!inMainList) {
              htmlContent += '<ul class="formatted-list">';
              inMainList = true;
            }
            
            const content = trimmedLine.substring(1).trim();
            htmlContent += `<li>${content}</li>`;
          }
          else if (trimmedLine) {
            // Regular text - close lists
            if (inMainList) {
              htmlContent += '</ul>';
              inMainList = false;
            }
            htmlContent += `<p>${trimmedLine}</p>`;
          }
        });
        
        // Close any remaining open lists
        if (inMainList) {
          htmlContent += '</ul>';
        }
        
        // Replace the paragraph content if we found list items
        if (htmlContent && htmlContent.includes('<ul>')) {
          p.outerHTML = htmlContent;
        }
      }
    });
  }

  /**
   * Merge P elements containing bullets ending with ":" with following UL elements
   * This handles ngx-markdown processed content
   */
  private mergeAdjacentLists(container: HTMLElement): void {
    
    // Get direct children only, not all nested elements
    const directChildren = Array.from(container.children) as HTMLElement[];
    
    for (let i = 0; i < directChildren.length - 1; i++) {
      const currentElement = directChildren[i];
      const nextElement = directChildren[i + 1];
      
      
      // Check if current element is a P with bullets and text ending in ":"
      if (currentElement.tagName === 'P' && nextElement.tagName === 'UL') {
        const pText = currentElement.textContent?.trim() || '';
        const pHtml = currentElement.innerHTML;
        
        // Check if paragraph contains bullets and ends with ":"
        if (pHtml.includes('•') && pText.endsWith(':')) {
          
          // Convert the paragraph bullets to a proper UL structure
          const lines = pHtml.split('\n');
          let newUlHtml = '<ul class="formatted-list">';
          
          lines.forEach((line) => {
            const trimmedLine = line.trim();
            if (trimmedLine.startsWith('•')) {
              const content = trimmedLine.substring(1).trim();
              newUlHtml += `<li>${content}</li>`;
            } else if (trimmedLine && !trimmedLine.startsWith('•')) {
              // Handle non-bullet lines (like headers with emojis)
              newUlHtml += `</ul><p>${trimmedLine}</p><ul class="formatted-list">`;
            }
          });
          
          newUlHtml += '</ul>';
          
          // Add class to the following UL
          nextElement.classList.add('formatted-sublist');
          
          // Create the new structure
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = newUlHtml;
          const newUl = tempDiv.querySelector('ul') as HTMLElement;
          
          if (newUl) {
            // Find the last li in our new UL (should be the one ending with ":")
            const lastLi = newUl.querySelector('li:last-child');
            if (lastLi && lastLi.textContent?.trim().endsWith(':')) {
              // Move the next UL inside this li
              lastLi.appendChild(nextElement);
            }
            
            // Replace the original P element with our new structure
            currentElement.replaceWith(newUl);
            
            break; // Process one at a time to avoid issues with changing DOM
          }
        }
      }
    } 
  }

/**
 * Dynamically apply 'wide-table' class to tables with more than 5 columns
 */
  private updateTableClasses(): void {
    try {
      const tables = this.elementRef.nativeElement.querySelectorAll('.markdown-content table');
      tables.forEach((table: HTMLTableElement) => {
        const columnCount = table.querySelector('tr')?.querySelectorAll('th, td').length || 0;
        if (columnCount > 5) {
          this.renderer.addClass(table, 'wide-table');
        } else {
          this.renderer.removeClass(table, 'wide-table');
        }
      });
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'updateTableClasses');
    }
  }

  /**
   * Dynamically apply 'wide-equation' class to LaTeX equations that exceed 80% of container width
   */
  private updateLatexScrollbars(): void {
    try {
      const latexEquations = this.elementRef.nativeElement.querySelectorAll('.markdown-content .katex-display');
      latexEquations.forEach((equation: HTMLElement) => {
        const container = equation.closest('.table-scroll-wrapper');
        if (container) {
          const containerWidth = container.clientWidth;
          const equationWidth = equation.scrollWidth;
          const widthPercentage = (equationWidth / containerWidth) * 100;
          
          if (widthPercentage > 80) {
            this.renderer.addClass(equation, 'wide-equation');
          } else {
            this.renderer.removeClass(equation, 'wide-equation');
          }
        }
      });

      // Also check inline LaTeX equations
      const inlineLatexEquations = this.elementRef.nativeElement.querySelectorAll('.markdown-content .katex:not(.katex-display)');
      inlineLatexEquations.forEach((equation: HTMLElement) => {
        const container = equation.closest('.table-scroll-wrapper');
        if (container) {
          const containerWidth = container.clientWidth;
          const equationWidth = equation.scrollWidth;
          const widthPercentage = (equationWidth / containerWidth) * 100;
          
          if (widthPercentage > 80) {
            this.renderer.addClass(equation, 'wide-equation');
          } else {
            this.renderer.removeClass(equation, 'wide-equation');
          }
        }
      });
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'updateLatexScrollbars');
    }
  }

  /**
   * Check if metadata structure is old (with serial keys) or new (direct object)
   */
  isOldMetadataStructure(metadataValue: any): boolean {
    if (!metadataValue || typeof metadataValue !== 'object') {
      return false;
    }
    
    // Check if any top-level key is a number (serial key from old structure)
    const keys = Object.keys(metadataValue);
    return keys.some(key => !isNaN(Number(key)));
  }
  /**
   * Check if a metadata item is blocked (contains only blocked: true)
   */
  isMetadataItemBlocked(item: any): boolean {
    if (!item || typeof item !== 'object') {
      return false;
    }
    
    // Check if item has blocked property set to true
    if (item.blocked === true) {
      // Check if this item only contains blocked and potentially key properties
      const keys = Object.keys(item);
      const allowedKeys = ['blocked', 'key'];
      const hasOnlyBlockedOrSystemKeys = keys.every(key => allowedKeys.includes(key));
      
      if (hasOnlyBlockedOrSystemKeys) {
        return true;
      }
    }
    
    return false;
  }

  /**
   * Convert old metadata structure to new array format
   * Filters out blocked items
   */
  convertOldMetadataToNewFormat(oldMetadata: any): any[] {
    if (!oldMetadata || typeof oldMetadata !== 'object') {
      return [];
    }
    
    const newMetadata: any[] = [];
    Object.keys(oldMetadata).forEach(key => {
      if (oldMetadata[key] && typeof oldMetadata[key] === 'object') {
        const metadataItem = {
          key: key,
          ...oldMetadata[key]
        };
        
        // Only add if not blocked
        if (!this.isMetadataItemBlocked(metadataItem)) {
          newMetadata.push(metadataItem);
        }
      }
    });
    
    return newMetadata;
  }

  /**
   * Parse and convert metadata from old chat sessions
   * Handles both nested (answer.metadata) and direct metadata structures
   */
  parseOldChatMetadata(metadataString: string): any[] {
    try {
      if (!metadataString) return [];
      
      const parsedMetadata = JSON.parse(metadataString);
      
      // Check for nested structure (answer.metadata)
      if (parsedMetadata && parsedMetadata.answer && parsedMetadata.answer.metadata) {
        // Handle new API format where metadata is already an array
        if (Array.isArray(parsedMetadata.answer.metadata)) {
          return parsedMetadata.answer.metadata;
        }
        // Handle old format where metadata needs conversion
        return this.convertOldMetadataToNewFormat(parsedMetadata.answer.metadata);
      }
      
      // Check for direct metadata structure
      if (parsedMetadata && typeof parsedMetadata === 'object') {
        // Check if it's a direct metadata object with numbered keys
        const keys = Object.keys(parsedMetadata);
        if (keys.some(key => !isNaN(Number(key)))) {
          return this.convertOldMetadataToNewFormat(parsedMetadata);
        }
      }
      
      return [];
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'parseOldChatMetadata');
      return [];
    }
  }

  extractVisualizationData(metadata: any): any[] {
    const parsedMetadata = JSON.parse(metadata);
    if (parsedMetadata && parsedMetadata.answer && parsedMetadata.answer.visualization) {
      const visualizationData = parsedMetadata.answer.visualization;
      return visualizationData;
    }
    return [];
  }

  onMicSpeechUpdate(text: string): void {
    this.txtChat = text;
    this.cdr.detectChanges();
  }

  onMicStatusUpdate(status: boolean): void {
    this.micActive = status;
    this.cdr.detectChanges();
  }

  // Handle news link click
  onNewsLinkClick(url: string): void {
    // You can add any additional logic here if needed
  }

  // Method to determine if no news data message should be shown for a specific chat item
  shouldShowNoNewsData(chatdata: any): boolean {
    // If the chat item has no news data and websocket is complete/data is saved, show no data message
    return chatdata && (!chatdata.newsAndUpdates || chatdata.newsAndUpdates.length === 0) && 
           this.websocketCompleteAndDataSaved[this.ChatQueriesList?.indexOf(chatdata)] === true;
  }

  // Tab switching functionality
  switchTab(tabName: string, event: Event): void {
    event.preventDefault();
    
    // Get the current response container
    const currentResponseContainer = (event.target as HTMLElement).closest('.response-info-text');
    if (!currentResponseContainer) return;
    
    // Remove active class from all tabs and content within this specific response container
    const tabItems = currentResponseContainer.querySelectorAll('.tab-item');
    const tabContents = currentResponseContainer.querySelectorAll('.tab-content');
    
    tabItems.forEach(item => item.classList.remove('active'));
    tabContents.forEach(content => content.classList.remove('active'));
    
    // Add active class to clicked tab
    const clickedTab = (event.target as HTMLElement).closest('.tab-item');
    if (clickedTab) {
      clickedTab.classList.add('active');
    }
    
    // Show corresponding content within the same response container
    const targetContent = currentResponseContainer.querySelector(`#${tabName}-tab`);
    if (targetContent) {
      targetContent.classList.add('active');
    }
    
    // Trigger change detection to ensure UI updates
    this.cdr.detectChanges();
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleFileUploadPopup(): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    this.fileUploadState.ui.isPopupOpen = !this.fileUploadState.ui.isPopupOpen;
    // Close dropdown if open when opening file upload popup
    if (this.fileUploadState.ui.isPopupOpen) {
      this.isDropdownOpen = false;
    }
  }

  onFileUploadOptionClick(option: string): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    // Close the popup after selection
    this.fileUploadState.ui.isPopupOpen = false;
    
    // Handle different options
    switch (option) {
      case 'local-files':
        this.onFileInputClick(); // Directly open file explorer
        break;
      case 'docs':
        this.handleDocsAccess();
        break;
      case 'workspace':
        this.handleWorkspaceAccess();
        break;
    }
  }

  private handleDocsAccess(): void {
    // TODO: Implement docs access functionality
    // console.log('Docs access triggered');
  }

  private handleWorkspaceAccess(): void {
    this.isMyFilesLoading = true
    this.isMyUploadedFiles = true
    this.fileUploadState.ui.isPopupOpen = false
    // Retrieve user's uploaded files
    this.uploadedFilesService.getUploadedFiles().subscribe({
      next: (response) => {
      const records = (response?.data?.records as any[]) || [];
      const applyToMyFiles = () => {
        if (!this.myFilesComponent) return;
        if (response?.code === 200) {
          this.myFilesComponent.retrievedFiles = records as any;
        } else if (records.length) {
          this.myFilesComponent.retrievedFiles = [
            ...this.myFilesComponent.retrievedFiles,
            ...records as any[]
          ];
        }
      };
      if (this.myFilesComponent) {
        applyToMyFiles();
      } else {
        setTimeout(applyToMyFiles, 0);
      }
        this.isMyFilesLoading = false;
      },
      error: (error) => {
        this.loggerService.logError(error, 'handleWorkspaceAccess');
        this.isMyFilesLoading = false;
      },
        
    });

  }

  onExistingFilesSelected(files: any[]): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    this.handleFiles([], { skipValidationAndUpload: true, existingFileInfos: files });
  }

  onExistingFileDeselected(file: any): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    try {
      const fileName: string = file?.documentName || file?.name || '';
      if (fileName) {
        this.cancelFileUpload(fileName);
      }
      // Also remove from uploadedFiles list to reflect UI immediately
      if (fileName) {
        const idx = this.fileUploadState.uploadedFiles.findIndex(f => f.name === fileName);
        if (idx !== -1) {
          this.fileUploadState.uploadedFiles.splice(idx, 1);
          if (this.fileUploadState.uploadedFiles.length === 0) {
            this.fileUploadState.ui.showFileCards = false;
          }
          setTimeout(() => {
            if (this.autoResizeDirective) {
              this.autoResizeDirective.adjustHeight();
              const element = this.autoResizeDirective.elementRef.nativeElement;
              const plainText = element.innerText || '';
              this.autoResizeDirective.updatePlaceholderVisibility(element, plainText);
            }
          }, 0);
        }
      }
    } catch (e) {
      this.loggerService.logError(this.ChatbotComponentError(e), 'onExistingFileDeselected');
    }
  }

  // File upload drag and drop methods
  onDragOver(event: DragEvent): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    
    this.fileUploadState.internal.dragCounter--;
    if (this.fileUploadState.internal.dragCounter === 0) {
      // Add a small delay to prevent flickering
      this.fileUploadState.internal.dragLeaveTimeout = setTimeout(() => {
        this.fileUploadState.ui.isDragOver = false;
      }, 50);
    }
  }

  onDrop(event: DragEvent): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    
    // Clear any pending timeout
    if (this.fileUploadState.internal.dragLeaveTimeout) {
      clearTimeout(this.fileUploadState.internal.dragLeaveTimeout);
      this.fileUploadState.internal.dragLeaveTimeout = null;
    }
    
    this.fileUploadState.ui.isDragOver = false;
    this.fileUploadState.internal.dragCounter = 0;
    
    if (event.dataTransfer?.files) {
      this.handleFiles(Array.from(event.dataTransfer.files));
    }
  }

  onDragEnter(event: DragEvent): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    
    // Clear any pending timeout
    if (this.fileUploadState.internal.dragLeaveTimeout) {
      clearTimeout(this.fileUploadState.internal.dragLeaveTimeout);
      this.fileUploadState.internal.dragLeaveTimeout = null;
    }
    
    this.fileUploadState.internal.dragCounter++;
    this.fileUploadState.ui.isDragOver = true;
  }

  private enforceMaxFilesLimit(incomingFilesCount: number, action: 'upload' | 'attach'): boolean {
    const currentUploadedCount = this.fileUploadState.uploadedFiles.length;
    const currentlyUploadingCount = this.fileUploadState.activeUploads.size;
    const maxFilesLimit = this.configdata?.FileUploadConfig?.maxFiles || 3;
    const totalFileCount = currentUploadedCount + currentlyUploadingCount + incomingFilesCount;
    
    if (totalFileCount > maxFilesLimit) {
      const verb = action === 'attach' ? 'attach' : 'upload';
      this.fileUploadState.validation.errors = [
        `Cannot ${verb} ${incomingFilesCount} file(s). You already have ${currentUploadedCount} uploaded and ${currentlyUploadingCount} uploading.`,
        `Maximum ${maxFilesLimit} files allowed.`
      ];
      this.fileUploadState.validation.showErrors = true;
      setTimeout(() => {
        this.dismissValidationErrors();
      }, 3000);
      return false;
    }
    return true;
    
  }

  private async handleFiles(files: File[], options?: { skipValidationAndUpload?: boolean; existingFileInfos?: any[] }): Promise<void> {
    if (!this.isFileUploadEnabled) {
      return;
    }
    
    // Clear previous errors
    this.fileUploadState.validation.errors = [];
    this.fileUploadState.validation.showErrors = false;
    
    // Early validation - check if any files provided (unless skipping for existing files)
    if (!options?.skipValidationAndUpload) {
      if (!files || files.length === 0) {
        return;
      }
    }

    // Fast-path: Attach existing files from My Files without validation/upload
    if (options?.skipValidationAndUpload) {
      try {
        const infos = options.existingFileInfos || [];
        if (!Array.isArray(infos) || infos.length === 0) {
          return;
        }
        // Respect the same max files constraint used for uploads
        if (!this.enforceMaxFilesLimit(infos.length, 'attach')) {
          return;
        }
        const mimeMap: any = {
          pdf: 'application/pdf',
          docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          txt: 'text/plain',
          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        };
        const added: any[] = [];
        infos.forEach((info: any) => {
          const name: string = info?.documentName || info?.name || '';
          const extFromName = (name.split('.').pop() || '').toLowerCase();
          const ext = (info?.fileType || extFromName || '').toLowerCase();
          const type = mimeMap[ext] || '';
          const size: number = typeof info?.fileSize === 'number' ? info.fileSize : 0;
          const documentId: number | undefined = info?.documentId;
          const displayFile: any = { name, size, type };
          if (!name) { return; }
          const exists = this.fileUploadState.uploadedFiles.some(f => f.name === name && f.size === size);
          if (!exists) {
            // Store the documentId in the map for later retrieval
            if (documentId) {
              const fileKey = `${name}_${size}`;
              this.fileToDocumentIdMap.set(fileKey, documentId);
            }
            this.fileUploadState.uploadedFiles = [...this.fileUploadState.uploadedFiles, (displayFile as unknown as File)];
            added.push(displayFile);
          }
        });
        if (added.length > 0) {
          this.fileUploadState.ui.showFileCards = true;
          setTimeout(() => {
            try {
              if (this.autoResizeDirective) {
                this.autoResizeDirective.adjustHeight();
                const element = this.autoResizeDirective.elementRef.nativeElement;
                const plainText = element.innerText || '';
                this.autoResizeDirective.updatePlaceholderVisibility(element, plainText);
              }
            } catch {}
          }, 0);
        }
      } catch (e) {
        this.loggerService.logError(this.ChatbotComponentError(e), 'handleFiles - attach existing');
      }
      return;
    }

    // Check if chatbot service and config are initialized
    if (!this.chatbotService || !this.configdata) {
      this.fileUploadState.validation.errors.push('System is still initializing. Please try again in a moment.');
      this.fileUploadState.validation.showErrors = true;
      setTimeout(() => {
        this.dismissValidationErrors();
      }, 3000);
      return;
    }

    // Check if total count would exceed limit (count completed + currently uploading + incoming)
    if (!this.enforceMaxFilesLimit(files.length, 'upload')) {
      return;
    }

    
    // Show loading indicator immediately when file processing starts
    this.fileUploadState.ui.isProcessing = true;
    
    // Initialize tracking for each file with UUID and initial status (keyed by docId)
    files.forEach(file => {
      const docId = this.globalConfigService.generateRequestId();
      this.fileUploadState.activeUploads.set(docId, {
        file: file,
        docId: docId,
        status: 'validating',
        progress: 0.0 // Start at 0%
      });
    });
    this.cdr.detectChanges();
    
    // Small delay to let UI show 0% state before progress starts
    await new Promise(resolve => setTimeout(resolve, 100));

    // Get config from config.json for additional validations
    const fileUploadConfig = config.FileUploadConfig;
    const allowedTypes = fileUploadConfig?.allowedTypes || [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/plain'
    ];
    const allowedExtensions = fileUploadConfig?.allowedExtensions || ['.pdf', '.docx', '.txt'];

    // ============================================================================
    // PARALLEL VALIDATION: All files are validated simultaneously
    // ============================================================================
    // Each file validation runs independently in its own promise, allowing:
    // - File type checks to run in parallel across all files
    // - File size checks to run in parallel across all files  
    // - Duplicate checks to run in parallel across all files
    // - Page count API calls to run in parallel across all PDF/DOCX files
    // This dramatically reduces validation time from sequential to concurrent
    // ============================================================================
    
    const validationPromises = files.map(async (file, currentIndex) => {
      try {
        // Update progress: 3% - Starting validation
        const trackerInfo = this.getTrackerByFile(file);
        if (trackerInfo) {
          trackerInfo.tracker.progress = 0.03;
          this.cdr.detectChanges();
        }

        // PARALLEL CHECK 1: File type validation (runs simultaneously for all files)
        const isValidType = allowedTypes.includes(file.type) || 
                           allowedExtensions.some(ext => file.name.toLowerCase().endsWith(ext));
        
        if (!isValidType) {
          return {
            file,
            isValid: false,
            error: `${file.name}: Invalid file type. Only PDF, DOCX, and TXT files are supported.`
          };
        }

        // Update progress: 7% - Type check passed
        if (trackerInfo) {
          trackerInfo.tracker.progress = 0.07;
          this.cdr.detectChanges();
        }

        // PARALLEL CHECK 2: File size validation (runs simultaneously for all files)
        let maxSize = 0;
        let sizeLimitText = '';
        
        if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
          maxSize = fileUploadConfig?.maxFileSizePDF || 3145728; // 3MB
          sizeLimitText = '3MB';
        } else if (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.name.toLowerCase().endsWith('.docx')) {
          maxSize = fileUploadConfig?.maxFileSizeDOCX || 3145728; // 3MB
          sizeLimitText = '3MB';
        } else if (file.type === 'text/plain' || file.name.toLowerCase().endsWith('.txt')) {
          maxSize = fileUploadConfig?.maxFileSizeTXT || 1048576; // 1MB
          sizeLimitText = '1MB';
        }
        
        if (file.size > maxSize) {
          return {
            file,
            isValid: false,
            error: `${file.name}: File size too large. Maximum size allowed is ${sizeLimitText}.`
          };
        }

        // Update progress: 10% - Size check passed
        if (trackerInfo) {
          trackerInfo.tracker.progress = 0.10;
          this.cdr.detectChanges();
        }

        // PARALLEL CHECK 3: Duplicate validation (runs simultaneously for all files)
        // Check against already uploaded files
        const isDuplicateExisting = this.fileUploadState.uploadedFiles.some(existingFile => 
          existingFile.name === file.name && existingFile.size === file.size
        );
        
        // Check against files in current batch (prevent selecting same file multiple times)
        const isDuplicateInBatch = files.some((otherFile, otherIndex) => 
          otherIndex < currentIndex && 
          otherFile.name === file.name && 
          otherFile.size === file.size
        );
        
        if (isDuplicateExisting) {
          return {
            file,
            isValid: false,
            error: `${file.name}: Duplicate file - already uploaded.`
          };
        }
        
        if (isDuplicateInBatch) {
          return {
            file,
            isValid: false,
            error: `${file.name}: Duplicate file ignored - selected multiple times.`
          };
        }

        // Update progress: 15% - Duplicate check passed
        if (trackerInfo) {
          trackerInfo.tracker.progress = 0.15;
          this.cdr.detectChanges();
        }

        // PARALLEL CHECK 4: Page count validation via API (runs simultaneously for all PDF/DOCX files)
        // This is the most time-consuming check, and parallelization provides the biggest benefit here
        if (file.type === 'application/pdf' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || 
            file.name.toLowerCase().endsWith('.pdf') || file.name.toLowerCase().endsWith('.docx')) {
          try {
            // Find tracker by file reference
            const trackerInfo = this.getTrackerByFile(file);
            if (trackerInfo) {
              trackerInfo.tracker.status = 'validating-pages';
              trackerInfo.tracker.progress = 0.18; // 18% - Starting page count check
              this.cdr.detectChanges();
            }
            
            // API call runs in parallel with other files' API calls
            const docId = trackerInfo?.tracker.docId || this.globalConfigService.generateRequestId();
            const pageCount = await this.chatbotService.getPageCount(file, docId, this.tenantID, this.UserID);
            // Store page count in tracker
            if (trackerInfo) {
              trackerInfo.tracker.pageCount = pageCount;
              trackerInfo.tracker.progress = 0.20; // 20% - Page count retrieved
              this.cdr.detectChanges();
            }
            
            if (pageCount > 30) {
              return {
                file,
                isValid: false,
                error: `${file.name}: File has ${pageCount} pages. Maximum 30 pages allowed.`
              };
            }
            
            // Page count validation passed
          } catch (error) {
            return {
              file,
              isValid: false,
              error: `${file.name}: Unable to verify page count. Please try again.`
            };
          }
        }

        // Update progress: 30% - All validations passed
        if (trackerInfo) {
          trackerInfo.tracker.progress = 0.30;
          this.cdr.detectChanges();
        }

        // All validations passed for this file
        return {
          file,
          isValid: true,
          error: null
        };
      } catch (error) {
        return {
          file,
          isValid: false,
          error: `${file.name}: Validation failed unexpectedly.`
        };
      }
    });

    // Wait for ALL file validations to complete simultaneously
    // Promise.allSettled ensures all validations finish even if some fail
    const validationResults = await Promise.allSettled(validationPromises);

    // Process validation results
    const validFiles: File[] = [];
    validationResults.forEach((result) => {
      if (result.status === 'fulfilled') {
        const validation = result.value;
        if (validation.isValid) {
          validFiles.push(validation.file);
        } else {
          this.fileUploadState.validation.errors.push(validation.error!);
          // Update tracker with error status and remove after showing error
          const trackerInfo = this.getTrackerByFile(validation.file);
          if (trackerInfo) {
            trackerInfo.tracker.status = 'error';
            trackerInfo.tracker.error = validation.error!;
            // Remove from tracking completely
            this.fileUploadState.activeUploads.delete(trackerInfo.docId);
          }
        }
      } else {
        // Promise was rejected (shouldn't happen with our try-catch, but handle it)
        this.fileUploadState.validation.errors.push(`Validation error: ${result.reason}`);
      }
    });

    // Show validation errors if any exist, but continue with valid files
    if (this.fileUploadState.validation.errors.length > 0) {
      this.fileUploadState.validation.showErrors = true;
      
      // Auto-dismiss validation errors after 5 seconds
      setTimeout(() => {
        this.dismissValidationErrors();
      }, 5000);
    }

    // Check if valid files would exceed the total limit
    const totalAfterUpload = this.fileUploadState.uploadedFiles.length + validFiles.length;
    const maxFiles = this.configdata?.FileUploadConfig?.maxFiles || 3;
    
    if (validFiles.length > 0 && totalAfterUpload <= maxFiles) {
      await this.uploadFilesToS3(validFiles);
    } else if (totalAfterUpload > maxFiles) {
      // Too many files even after filtering duplicates
      const allowedCount = maxFiles - this.fileUploadState.uploadedFiles.length;
      this.fileUploadState.validation.errors.push(`Cannot upload ${validFiles.length} files. Only ${allowedCount} more files allowed.`);
      this.fileUploadState.validation.showErrors = true;
      this.fileUploadState.ui.isProcessing = false;
      
      // Clean up progress tracking
      validFiles.forEach(file => {
        const trackerInfo = this.getTrackerByFile(file);
        if (trackerInfo) {
          this.fileUploadState.activeUploads.delete(trackerInfo.docId);
        }
      });
    } else {
      // No valid files to upload
      this.fileUploadState.ui.isProcessing = false;
      
      // Clean up tracking for files that didn't make it
      files.forEach(file => {
        if (!validFiles.includes(file)) {
          const trackerInfo = this.getTrackerByFile(file);
          if (trackerInfo) {
            this.fileUploadState.activeUploads.delete(trackerInfo.docId);
          }
        }
      });
    }
  }
  /**
   * Uploads files to S3 using the chatbot service
   * @param files - Array of files to upload
   */
  private async uploadFilesToS3(files: File[]): Promise<void> {
    try {
      
      // Update status to uploading and prepare files with their doc_ids
      const filesWithDocIds = files.map(file => {
        const trackerInfo = this.getTrackerByFile(file);
        if (trackerInfo) {
          trackerInfo.tracker.status = 'uploading';
          trackerInfo.tracker.progress = 0.35; // 35% - Starting S3 upload
        }
        return {
          file: file,
          docId: trackerInfo?.tracker.docId || this.globalConfigService.generateRequestId()
        };
      });
      
      // To upload files (parallel uploads)
      const uploadResult = await this.fileUploadService.uploadFiles(filesWithDocIds, this.UserID, this.tenantID);

      // Update progress after S3 upload completes and remap trackers with real documentId
      if (uploadResult.success) {
        uploadResult.uploadedFiles.forEach((u: any) => {
          if (u.uploadSuccess && u.documentId) {
            // Find tracker by file (since the key might be a UUID)
            const trackerInfo = this.getTrackerByFile(u.file);
            if (trackerInfo) {
              const oldKey = trackerInfo.docId;
              const newKey = u.documentId.toString();
              
              // Update tracker progress
              trackerInfo.tracker.progress = 0.30; // 30% - S3 upload complete
              
              // Start progress simulation while waiting for WebSocket (~30s wait)
              // Increments 3.5% every second, caps at 95%
              const simulationInterval = setInterval(() => {
                const currentProgress = trackerInfo.tracker.progress || 0.30;
                if (trackerInfo.tracker.status === 'success' || trackerInfo.tracker.status === 'error' || 
                    currentProgress >= 0.80) {
                  clearInterval(simulationInterval);
                  return;
                }
                trackerInfo.tracker.progress = Math.min(currentProgress + 0.025, 0.80);
                this.cdr.detectChanges();
              }, 1000);
              
              // If the key changed, remap the tracker
              if (oldKey !== newKey) {
                // Remove old key and add with new key
                this.fileUploadState.activeUploads.delete(oldKey);
                trackerInfo.tracker.docId = newKey;
                this.fileUploadState.activeUploads.set(newKey, trackerInfo.tracker);
              }
            }
          }
        });
        this.cdr.detectChanges();
      }

      if (uploadResult.success) {
        await this.trackFileProcessingStatus(uploadResult);
      }

      
      // Show errors if any uploads failed
      if (uploadResult.errors.length > 0) {
        uploadResult.errors.forEach(error => {
          this.fileUploadState.validation.errors.push(error);
        });
        this.fileUploadState.validation.showErrors = true;
        // Auto-dismiss after 5 seconds
        setTimeout(() => {
          this.dismissValidationErrors();
        }, 5000);
      }
    } catch (error) {
      
      // Update tracker with error and remove from progress tracking
      files.forEach(file => {
        const trackerInfo = this.getTrackerByFile(file);
        if (trackerInfo) {
          trackerInfo.tracker.status = 'error';
          trackerInfo.tracker.error = 'Upload failed';
          this.fileUploadState.activeUploads.delete(trackerInfo.docId);
        }
      });
      
      this.loggerService.logError(this.ChatbotComponentError(error), 'uploadFilesToS3');
      this.fileUploadState.validation.errors.push('Failed to upload files. Please try again.');
      this.fileUploadState.validation.showErrors = true;
      // Auto-dismiss after 3 seconds
      setTimeout(() => {
        this.dismissValidationErrors();
      }, 3000);
    } finally {
    }
  }

  /**
 * Tracks file processing status via websocket after successful S3 upload
 * Uses a single WebSocket connection for all files in parallel
 * @param uploadResult - Object containing upload results
 */
  private async trackFileProcessingStatus(uploadResult: any): Promise<void> {
    try {
      const uploads = uploadResult?.uploadedFiles ?? [];
      
      if (uploads.length === 0) {
        return;
      }

      // Ensure all files show uploading status (progress already set from S3 upload)
      uploads.forEach((u: any) => {
        try {
          const tracker = this.fileUploadState.activeUploads.get(u.docId);
          if (tracker) {
            tracker.status = 'uploading';
            // Progress is already at 0.50 from S3 upload, don't reset it
          }
        } catch (error) {
          this.loggerService.logError(this.ChatbotComponentError(error), 'trackFileProcessingStatus - status update');
        }
      });

      try {
        // STEP 1: Establish WebSocket connection and authenticate ONCE before processing any files
        await this.chatbotService.FileStatusTracker({
          tenantId: this.tenantID,
          userId: this.UserID,
          accssToken: this.tokenService.getAccessToken()
        });

        // STEP 2: Now that connection is ready, send all file tracking requests in parallel
        uploads.forEach((u: any) => {
          try {
            // Use documentId (the real backend ID) instead of the UUID docId
            const docId = (u.documentId || u.docId).toString();
            const s3Key = u.s3Key;
            const file = u.file;
            const presignedUrl = u.presignedDownloadUrl;
            const fileType = u.fileType || file.type;
            const fileSize = u.fileSize || file.size;

            if (!docId || !s3Key || !file?.name) {
              this.loggerService.logError(`Missing required data for file tracking: docId=${docId}, s3Key=${s3Key}, fileName=${file?.name}`, 'trackFileProcessingStatus');
              return;
            }

            const fileStatusData = {
              tenantId: this.tenantID,
              userId: this.UserID,
              docName: file.name,
              docId: docId,
              s3Key: s3Key,
              accssToken: this.tokenService.getAccessToken(),
              presignedUrl: presignedUrl || '',
              docType: fileType || '',
              docSize: fileSize || 0
            };

            // Connection is already established, so FileStatusTracker will immediately send the payload
            this.chatbotService.FileStatusTracker(fileStatusData).then(observable => {
              // Subscribe to the observable for this specific file
              observable.subscribe({
                next: (resp) => {
                  try {
                    const tracker = this.fileUploadState.activeUploads.get(docId);
                    if (!tracker) {
                      return;
                    }

                    // Update progress: Map WebSocket progress to remaining 50% (50%-100%)
                    // S3 upload completed at 50%, so WebSocket processing covers the remaining 50%
                    this.updateFileProgress(tracker, resp);

                    // Update status for display
                    if (resp.status === 'completed' || resp.status === 'success') {
                      this.handleFileUploadComplete(docId, file, tracker);
                    } else if (resp.status === 'failed' || resp.status === 'error') {
                      this.handleFileUploadError(docId, tracker, 'Processing failed');
                    } else {
                      // 'started' | 'inprogress' | 'processing' → keep showing loader
                      tracker.status = 'uploading';
                    }

                    // Force UI update to show progress changes immediately
                    this.cdr.detectChanges();
                  } catch (error) {
                    this.loggerService.logError(this.ChatbotComponentError(error), 'trackFileProcessingStatus - response handler');
                    const tracker = this.fileUploadState.activeUploads.get(docId);
                    if (tracker) {
                      this.handleFileUploadError(docId, tracker, 'Response processing error');
                    }
                  }
                },
                error: (error) => {
                  this.loggerService.logError(this.ChatbotComponentError(error), `FileStatusTracker error for ${file.name}`);
                  const tracker = this.fileUploadState.activeUploads.get(docId);
                  if (tracker) {
                    this.handleFileUploadError(docId, tracker, 'Connection error');
                  }
                  this.cdr.detectChanges();
                }
              });
            }).catch(error => {
              this.loggerService.logError(this.ChatbotComponentError(error), `trackFileProcessingStatus - FileStatusTracker failed for ${file.name}`);
              const tracker = this.fileUploadState.activeUploads.get(docId);
              if (tracker) {
                this.handleFileUploadError(docId, tracker, 'Failed to connect');
              }
              this.cdr.detectChanges();
            });
          } catch (error) {
            this.loggerService.logError(this.ChatbotComponentError(error), 'trackFileProcessingStatus - file processing loop');
          }
        });

      } catch (error) {
        // Connection establishment failed
        this.loggerService.logError(this.ChatbotComponentError(error), 'trackFileProcessingStatus - WebSocket connection failed');
        
        // Mark all files as error
        uploads.forEach((u: any) => {
          try {
            const tracker = this.fileUploadState.activeUploads.get(u.docId);
            if (tracker) {
              tracker.status = 'error';
              tracker.error = 'Connection failed';
            }
          } catch (error) {
            this.loggerService.logError(this.ChatbotComponentError(error), 'trackFileProcessingStatus - error state update');
          }
        });
        
        // Clean up after showing errors
        setTimeout(() => {
          uploads.forEach((u: any) => {
            this.fileUploadState.activeUploads.delete(u.docId);
          });
          this.fileUploadState.ui.isProcessing = false;
        }, 3000);
        
        this.cdr.detectChanges();
      }
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'trackFileProcessingStatus - outer exception');
      this.fileUploadState.ui.isProcessing = false;
      this.cdr.detectChanges();
    }
  }

  /**
   * Updates file progress based on WebSocket response
   */
  private updateFileProgress(tracker: FileUploadTracker, resp: any): void {
    try {
      const currentProgress = tracker.progress || 0;
      
      // Handle completion - always jump to 100%
      if (resp.status === 'completed' || resp.status === 'success') {
        tracker.progress = 1.0;
        return;
      }
      
      // For other messages, just increment by 1.5% but never go backwards
      const newProgress = Math.min(currentProgress + 0.015, 0.99);
      tracker.progress = Math.max(currentProgress, newProgress);
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'updateFileProgress');
    }
  }

  /**
   * Handles successful file upload completion
   */
  private handleFileUploadComplete(docId: string, file: File, tracker: FileUploadTracker): void {
    try {
      // Store the file to documentId mapping
      const fileKey = `${file.name}_${file.size}`;
      this.fileToDocumentIdMap.set(fileKey, parseInt(docId));
      
      // Add to uploadedFiles only now (prevent duplicates)
      const exists = this.fileUploadState.uploadedFiles.some(
        f => f.name === file.name && f.size === file.size
      );
      
      if (!exists) {
        this.fileUploadState.uploadedFiles = [...this.fileUploadState.uploadedFiles, file];
        this.fileUploadState.ui.showFileCards = true;
        
        // Trigger height adjustment after file addition
        setTimeout(() => {
          try {
            if (this.autoResizeDirective) {
              this.autoResizeDirective.adjustHeight();
              const element = this.autoResizeDirective.elementRef.nativeElement;
              const plainText = element.innerText || '';
              this.autoResizeDirective.updatePlaceholderVisibility(element, plainText);
            }
          } catch (error) {
            this.loggerService.logError(this.ChatbotComponentError(error), 'handleFileUploadComplete - height adjustment');
          }
        }, 0);
      }

      // Remove from activeUploads immediately to hide the uploading pill
      this.fileUploadState.activeUploads.delete(docId);
      this.cdr.detectChanges();
      
      // Check if all uploads are complete
      this.checkAllUploadsComplete();
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'handleFileUploadComplete');
    }
  }

  /**
   * Handles file upload errors with cleanup
   */
  private handleFileUploadError(docId: string, tracker: FileUploadTracker, errorMessage: string): void {
    try {
      tracker.status = 'error';
      tracker.error = errorMessage;
      this.loggerService.logError(`File upload error for docId ${docId}: ${errorMessage}`, 'handleFileUploadError');
      
      // Remove from activeUploads after showing error
      setTimeout(() => {
        try {
          this.fileUploadState.activeUploads.delete(docId);
          this.checkAllUploadsComplete();
        } catch (error) {
          this.loggerService.logError(this.ChatbotComponentError(error), 'handleFileUploadError - cleanup');
        }
      }, 3000);
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'handleFileUploadError');
    }
  }

  /**
   * Checks if all uploads are complete and updates UI state
   */
  private checkAllUploadsComplete(): void {
    try {
      if (this.fileUploadState.activeUploads.size === 0) {
        this.fileUploadState.ui.isProcessing = false;
      }
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'checkAllUploadsComplete');
    }
  }

  onFileInputClick(): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = '.pdf,.docx,.txt';
    input.onchange = (event: any) => {
      if (event.target.files) {
        this.handleFiles(Array.from(event.target.files));
      }
    };
    input.click();
  }

  removeFile(index: number): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    const removedFile = this.fileUploadState.uploadedFiles[index];
    this.fileUploadState.uploadedFiles.splice(index, 1);
    
    // Clean up the tracker if file is being processed
    if (removedFile) {
      const trackerInfo = this.getTrackerByFile(removedFile);
      if (trackerInfo) {
        this.fileUploadState.activeUploads.delete(trackerInfo.docId);
      }
    }
    
    if (this.fileUploadState.uploadedFiles.length === 0) {
      this.fileUploadState.ui.showFileCards = false;
    }
    // Trigger height adjustment and placeholder update after file removal
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.adjustHeight();
        // Force placeholder visibility update
        const element = this.autoResizeDirective.elementRef.nativeElement;
        const plainText = element.innerText || '';
        this.autoResizeDirective.updatePlaceholderVisibility(element, plainText);
      }
    }, 0);
  }

  /**
   * Clear all file uploads when switching sessions or modules
   * This method resets the entire file upload state
   */
  clearFileUploads(): void {
    try {
      // Clear all uploaded files
      this.fileUploadState.uploadedFiles = [];
      
      // Clear all active uploads/trackers
      this.fileUploadState.activeUploads.clear();
      
      // Reset UI state
      this.fileUploadState.ui.showFileCards = false;
      this.fileUploadState.ui.isDragOver = false;
      this.fileUploadState.ui.isPopupOpen = false;
      this.fileUploadState.ui.isProcessing = false;
      
      // Clear validation errors
      this.fileUploadState.validation.errors = [];
      this.fileUploadState.validation.showErrors = false;
      
      // Reset internal counters
      this.fileUploadState.internal.dragCounter = 0;
      if (this.fileUploadState.internal.dragLeaveTimeout) {
        clearTimeout(this.fileUploadState.internal.dragLeaveTimeout);
        this.fileUploadState.internal.dragLeaveTimeout = null;
      }
      
      // Trigger height adjustment and placeholder update after clearing files
      setTimeout(() => {
        if (this.autoResizeDirective) {
          this.autoResizeDirective.adjustHeight();
          // Force placeholder visibility update
          const element = this.autoResizeDirective.elementRef.nativeElement;
          const plainText = element.innerText || '';
          this.autoResizeDirective.updatePlaceholderVisibility(element, plainText);
        }
      }, 0);
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), "clearFileUploads");
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    const size = bytes / Math.pow(k, i);
    
    // Format based on size unit
    if (i === 0) {
      return Math.round(size) + ' ' + sizes[i]; // Bytes - no decimals
    } else if (i === 1) {
      return Math.round(size) + sizes[i]; // KB - no decimals, no space
    } else {
      return size.toFixed(1) + sizes[i]; // MB/GB - 1 decimal, no space
    }
  }

  /**
   * Generates a UUID v4
   * 
   * SECURITY: Uses cryptographically secure random generation
   * Fallback to crypto.getRandomValues() instead of Math.random()
   * 
   * @returns A UUID v4 string
   */
  private generateUUID(): string {
    // SECURITY: Primary - use crypto.randomUUID() (cryptographically secure)
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    
    // SECURITY: Fallback - use crypto.getRandomValues() (cryptographically secure)
    if (crypto && crypto.getRandomValues) {
      const array = new Uint8Array(16);
      crypto.getRandomValues(array);
      const hex = Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
      return [
        hex.slice(0, 8),
        hex.slice(8, 12),
        '4' + hex.slice(13, 16),
        ((parseInt(hex.slice(16, 17), 16) & 0x3) | 0x8).toString(16) + hex.slice(17, 20),
        hex.slice(20, 32)
      ].join('-');
    }
    
    // SECURITY: Last resort - timestamp-based for legacy browsers
    const timestamp = Date.now();
    const perfNow = (typeof performance !== 'undefined' && performance.now) ? performance.now() : 0;
    let d = timestamp;
    let d2 = (perfNow * 1000) | 0;
    
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      let r;
      if (d > 0) {
        r = (d + d2) % 16 | 0;
        d = Math.floor(d / 16);
      } else {
        r = (d2) % 16 | 0;
        d2 = Math.floor(d2 / 16);
      }
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  dismissValidationErrors(): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    this.fileUploadState.validation.showErrors = false;
    this.fileUploadState.validation.errors = [];
  }

  cancelFileUpload(fileName: string): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    // Find and remove the file tracker by filename
    for (const [docId, tracker] of this.fileUploadState.activeUploads.entries()) {
      if (tracker.file.name === fileName) {
        this.fileUploadState.activeUploads.delete(docId);
        break;
      }
    }
    
    // If no more files are being processed, hide the loading indicator
    if (this.fileUploadState.activeUploads.size === 0) {
      this.fileUploadState.ui.isProcessing = false;
    }
  }

  async selectOption(option: DataSetVdb): Promise<void> {
    // Check if the option is actually different
    if (this.selectedVectorDbDataset?.value === option?.value) {
      this.isDropdownOpen = false;
      return;
    }

    this.selectedVectorDbDataset = option;
    this.isDropdownOpen = false;
    if(this.isDomainManagementEnabled){
    // Update domains list when module changes
      await this.updateDomainsList();
    }
    this.handleChange();
    this.resizeDropdownWidth();
  }

  @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event): void {
      const target = event.target as HTMLElement;
      if (!this.elementRef.nativeElement.querySelector('.custom-dropdown')?.contains(target)) {
        this.isDropdownOpen = false;
      }
      if (!this.elementRef.nativeElement.querySelector('.file-upload-popup-container')?.contains(target)) {
        this.fileUploadState.ui.isPopupOpen = false;
      }
      // Close help menu when clicking outside of it and the help FAB
      if (this.showHelpMenu) {
        const helpMenuEl = this.elementRef.nativeElement.querySelector('.help-menu-popup');
        const helpFabEl = this.elementRef.nativeElement.querySelector('.help-fab');
        const clickedInsideHelpMenu = (helpMenuEl && helpMenuEl.contains(target)) || (helpFabEl && helpFabEl.contains(target));
        if (!clickedInsideHelpMenu) {
          this.showHelpMenu = false;
        }
      }
    }

  /**
   * Measures the text width using canvas with unified cross-platform approach
   */
  private measureTextWidth(text: string): number {
    if (!text || text.trim() === '') return 0;
    
    if (!this.textMeasureCanvas) {
      this.textMeasureCanvas = document.createElement('canvas');
    }
    
    const context = this.textMeasureCanvas.getContext('2d');
    if (!context) return 0;
    
    try {
      // Use a consistent font stack that works well on both Windows and Mac
      context.font = '14px system-ui, -apple-system, "Segoe UI", "Roboto", "Helvetica Neue", "Arial", sans-serif';
      
      // Set consistent text properties for reliable measurement
      context.textBaseline = 'alphabetic';
      context.textAlign = 'left';
      
      const metrics = context.measureText(text);
      
      // Add consistent padding for reliable display across platforms
      return metrics.width + 2; // Small buffer for consistent appearance
      
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'measureTextWidth');
      // Consistent fallback for all platforms
      return text.length * 8.2; // Average character width
    }
  }

  /**
   * Calculates the optimal dropdown width based on content with consistent cross-platform behavior
   */
  private calculateDropdownWidth(): number {
    if (!this.vectorDbDatasets || this.vectorDbDatasets.length === 0) {
      return 190; // Default width
    }

    let maxWidth = 0;
    const padding = 48; // Consistent padding for arrow, margins, and spacing
    const minWidth = 140; // Minimum dropdown width
    const maxAllowedWidth = 320; // Maximum dropdown width to prevent overflow
    
    try {
      // Measure the currently selected option
      const selectedText = this.getSelectedOptionLabel();
      if (selectedText) {
        const selectedWidth = this.measureTextWidth(selectedText);
        maxWidth = Math.max(maxWidth, selectedWidth);
      }

      // Measure all dropdown options
      this.vectorDbDatasets.forEach(option => {
        const name = this.translate.instant(option.name);
        const favName = this.translate.instant(this.favouriteDataset || '');
        const optionText = name === favName ? `@${name} ⭐` : `@${name}`;
        const textWidth = this.measureTextWidth(optionText);
        maxWidth = Math.max(maxWidth, textWidth);
      });
    } catch (error) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'calculateDropdownWidth');
      return 190; // Fallback to default width
    }

    // Apply consistent constraints and padding for all platforms
    const finalWidth = Math.min(Math.max(maxWidth + padding, minWidth), maxAllowedWidth);
    return Math.ceil(finalWidth);
  }

  /**
   * Updates the dropdown width based on content
   */
  private updateDropdownWidth(): void {
    this.dropdownWidth = this.calculateDropdownWidth();
    this.cdr.detectChanges();
  }

  /**
   * Resizes dropdown when dataset changes
   */
  resizeDropdownWidth(): void {
    // Use setTimeout to ensure DOM is updated before measuring
    setTimeout(() => {
      this.updateDropdownWidth();
    }, 0);
  }

  /**
   * Shows a toast message when microphone permission is denied
   */
  onMicSpeechError(error: string): void {
    if (error === 'MIC_PERMISSION_DENIED' || error === 'MIC_PERMISSION_NETWORK_ERROR' || error === 'MIC_UNKNOWN_ERROR') {
      this.IsCustomErrorMessageVisible = true;
      const translatedApologyMsg = this.translate.instant(error);
      this.CustomErrorMessageText = translatedApologyMsg;
      setTimeout(() => {
          this.IsCustomErrorMessageVisible = false;
      }, 4000);
      this.cdr.detectChanges();
    }
  }

  onSuggestionSelected(domain: string) {
    
    // Find the position of the last @ symbol
    const lastAtIndex = this.txtChat.lastIndexOf('@');
    
    if (lastAtIndex !== -1) {
      // Replace from @ to the end with the selected domain
      const beforeAt = this.txtChat.substring(0, lastAtIndex);
      this.txtChat = `${beforeAt}@${domain} `;
    } else {
      // If no @ found, just append the domain with @
      this.txtChat = this.txtChat + `@${domain} `;
    }
    if(this.isDomainManagementEnabled){
      // Update the selected domains list
      this.updateSelectedDomains();
    }
    this.cdr.detectChanges();
    
    // Trigger highlighting after domain selection
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.triggerHighlighting();
      }
    }, 150);
  }

  /**
   * Updates the userSelectedDomains list based on @mentions in txtChat
   * If no domains are mentioned with @, defaults to none
   */
  updateSelectedDomains() {
    if (!this.txtChat) {
      this.userSelectedDomains = []; // Default to none when no text
      return;
    }

    const validDomains = new Set(this.allDomainNamesList.map(d => d.toLowerCase()));
    
    // Regular expression to find all @mentions, followed by a word
    const mentionsInText = (this.txtChat.match(/@([a-zA-Z0-9]+)/g) || [])
                          .map((mention: any) => mention.substring(1).toLowerCase());
    
    // Filter the mentions to only include valid domains and maintain their order
    const newSelectedDomains: string[] = [];
    const seenDomains = new Set<string>();

    mentionsInText.forEach((mention: any) => {
      if (validDomains.has(mention) && !seenDomains.has(mention)) {
        // Find the original case from allDomainNamesList
        const originalDomain = this.allDomainNamesList.find(d => d.toLowerCase() === mention);
        if (originalDomain) {
          newSelectedDomains.push(originalDomain.toUpperCase());
          seenDomains.add(mention.toUpperCase());
        }
      }
    });
    
    // If no valid domains were found in @mentions, default to none
    if (newSelectedDomains.length === 0) {
      this.userSelectedDomains = [];
    } else {
      this.userSelectedDomains = newSelectedDomains;
    }

  }

  onTextInput() {
    setTimeout(() => {
      if(this.isDomainManagementEnabled){
        this.updateSelectedDomains();
      }
      // Trigger highlighting for manual domain entry
      if (this.autoResizeDirective && this.txtChat && this.txtChat.includes('@')) {
        this.autoResizeDirective.triggerHighlighting();
      }
      if (this.autoResizeDirective && this.txtChat && this.txtChat.includes('/')) {
        this.isMyUploadedFiles = true;
        this.isMyFilesLoading = true
        this.uploadedFilesService.getUploadedFiles().subscribe({
      next: (response) => {
      const records = (response?.data?.records as any[]) || [];
      const applyToMyFiles = () => {
        if (!this.myFilesComponent) return;
        if (response?.code === 200) {
          this.myFilesComponent.retrievedFiles = records as any;
        } else if (records.length) {
          this.myFilesComponent.retrievedFiles = [
            ...this.myFilesComponent.retrievedFiles,
            ...records as any[]
          ];
        }
      };
      if (this.myFilesComponent) {
        applyToMyFiles();
      } else {
        setTimeout(applyToMyFiles, 0);
      }
        this.isMyFilesLoading = false
      },
      error: (error) => {
        this.loggerService.logError(error, 'handleWorkspaceAccess');
        this.isMyFilesLoading = false
      },
        
    });
      }
    }, 0);
  }

  /**
   * Get selected domains with proper fallback to none
   * Ensures always returns a valid array for JSON serialization
   */
  getSelectedDomains(): string[] {
    if (this.userSelectedDomains && Array.isArray(this.userSelectedDomains) && this.userSelectedDomains.length > 0) {
      return this.userSelectedDomains;
    }
    return [];
  }

  /**
   * Get available domains with proper fallback to MPR
   * Ensures always returns a valid array for JSON serialization
   */
  getAvailableDomains(): string[] {
    if (this.allDomainNamesList && Array.isArray(this.allDomainNamesList) && this.allDomainNamesList.length > 0) {
      return this.allDomainNamesList;
    }
    return [];
  }

  onDomainInserted() {
    // Trigger highlighting when domain is inserted from suggestions
    setTimeout(() => {
      if (this.autoResizeDirective) {
        this.autoResizeDirective.triggerHighlighting();
        
        // After highlighting, ensure cursor is at the end
        setTimeout(() => {
          const element = this.autoResizeDirective.elementRef?.nativeElement;
          if (element) {
            const textContent = element.textContent || '';
            // Place cursor at the end
            this.placeCaretAtEnd(element);
          }
        }, 100);
      }
    }, 50);
  }

  private placeCaretAtEnd(element: HTMLElement): void {
    if (typeof window === 'undefined') return;
    
    const selection = window.getSelection();
    if (!selection) return;

    const range = document.createRange();
    range.selectNodeContents(element);
    range.collapse(false); // false means collapse to end
    
    selection.removeAllRanges();
    selection.addRange(range);
  }

  onDatasetToggled(event: {datasetName: string, isExpanded: boolean}): void {
    // Only fetch sessions when dataset is expanded, not when collapsed
    if (event.isExpanded) {
      this.loadSessionsForDataset(event.datasetName);
    }
  }

  async loadSessionsForDataset(datasetName: string): Promise<void> {
    // Initialize pagination tracking for this dataset if not exists
    if (!this.datasetPagination[datasetName]) {
      this.datasetPagination[datasetName] = {
        currentPage: 1,
        hasMoreData: true
      };
    }

    // Check if we already have sessions for this dataset
    const existingSessions = this.chatSessionList.filter((session: any) => 
      session.module_name?.toLowerCase() === datasetName?.toLowerCase()
    );
    const hasExistingSessions = existingSessions.length > 0;
    
    // If we already have sessions for this dataset, don't fetch again
    // This prevents unnecessary API calls when expanding a dataset folder that already has loaded sessions
    if (hasExistingSessions) {
      return;
    }

    this.loadSessionsForDatasetPage(datasetName, this.datasetPagination[datasetName].currentPage);
  }

  async loadMoreSessionsForDataset(datasetName: string): Promise<void> {
    // Initialize pagination if not exists
    if (!this.datasetPagination[datasetName]) {
      this.datasetPagination[datasetName] = {
        currentPage: 1,
        hasMoreData: true
      };
      return;
    }

    // Check if we have more data to load
    if (!this.datasetPagination[datasetName].hasMoreData) {
      return;
    }

    // Load next page
    const nextPage = this.datasetPagination[datasetName].currentPage + 1;
    this.loadSessionsForDatasetPage(datasetName, nextPage);
  }

  private async loadSessionsForDatasetPage(datasetName: string, page: number): Promise<void> {
    // Prepare API call parameters similar to GetChatSessionsInfo but for specific module
    const defaultDays = this.getDaysFromFilter(this.selectedFilter || '30 Days');
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - defaultDays);

    const startDateFormatted = this.formatDateToDB(startDate);
    const endDateFormatted = this.formatDateToDB(endDate);
    const version = 2;
    const selectedDomain = this.isDomainManagementEnabled ? [this.moduleName] : [environment.DomainName];
    
    // Use the specific dataset/module name for the API call
    const modules: string[] = [datasetName];

    
    // Initialize loading state for this dataset if not exists
    if (this.datasetLoadingStates[datasetName] === undefined) {
      this.datasetLoadingStates[datasetName] = false;
    }
    
    // Initialize pagination for this dataset if not exists
    if (!this.datasetPagination[datasetName]) {
      this.datasetPagination[datasetName] = {
        currentPage: 0,
        hasMoreData: true
      };
    }
    
    this.datasetLoadingStates[datasetName] = true;

    this.chatbotService.GetChatSessions(
      this.UserID, 
      this.tenantID, 
      selectedDomain, 
      page, 
      this.pageSize, 
      startDateFormatted, 
      endDateFormatted, 
      version, 
      modules, 
      this.isDomainManagementEnabled
    ).subscribe({
      next: async (response: any) => {
        this.datasetLoadingStates[datasetName] = false;
        if (response.status === 200) {
          if (response.body && response.body.data) {
            const allSessions = [];

            // Store module-specific total count (only for page 1 to avoid duplicates)
            if (page === 1 && response.body.total !== undefined) {
              this.moduleThreadsCounts[datasetName.toLowerCase()] = response.body.total;
              // Mark this dataset as having had its API triggered
              this.datasetApiTriggered[datasetName.toLowerCase()] = true;
            }

            // Process the response for this specific module
            for (const module in response.body.data) {
              if (response.body.data.hasOwnProperty(module)) {
                const sessions = response.body.data[module];
                const transformedSessions = await this.transformNewSessionDataToOldFormat(sessions);
                
                if (Array.isArray(transformedSessions)) {
                  const newSessions = transformedSessions.map((item: any) => ({ ...item, isChecked: false }));
                  allSessions.push(...newSessions);
                }
              }
            }

            // Update pagination tracking only if data was successfully received
            if (allSessions.length > 0) {
              this.datasetPagination[datasetName].currentPage = page;
              
              // Check if there is more data to load
              if (allSessions.length < this.pageSize) {
                this.datasetPagination[datasetName].hasMoreData = false;
              }
            } else {
              // No data received, stop pagination for this dataset
              this.datasetPagination[datasetName].hasMoreData = false;
            }

            // Append new sessions to existing chat session list (don't replace)
            if (allSessions.length > 0) {
              // Filter out any duplicate sessions based on session_id to prevent duplicates
              const newSessions = allSessions.filter((newSession: any) => 
                !this.chatSessionList.some((existingSession: any) => 
                  existingSession.session_id === newSession.session_id
                )
              );
              
              if (newSessions.length > 0) {
                this.chatSessionList = [...this.chatSessionList, ...newSessions];
                
                // Sort all sessions by modified_date (updated_at) to maintain chronological order
                this.chatSessionList = this.chatSessionList.sort((a: any, b: any) => {
                  // Handle 'New Topic' - keep it at top
                  if (a.chat_name === 'New Topic') return -1;
                  if (b.chat_name === 'New Topic') return 1;
                  
                  // Sort by modified_date (updated_at) - newest first
                  const dateA = a.modified_date ? new Date(a.modified_date).getTime() : 0;
                  const dateB = b.modified_date ? new Date(b.modified_date).getTime() : 0;
                  return dateB - dateA;
                });
              } else {
              }
            } else if (page === 1) {
              // No sessions found for first page
            }
          } else {
            // No data in response
            this.datasetPagination[datasetName].hasMoreData = false;
          }
        } else {
          this.loggerService.logError(`Failed to load sessions for dataset ${datasetName}, page ${page}: ${JSON.stringify(response)}`, 'loadSessionsForDataset');
          this.datasetPagination[datasetName].hasMoreData = false;
        }
      },
      error: (error) => {
        this.datasetLoadingStates[datasetName] = false;
        this.datasetPagination[datasetName].hasMoreData = false;
        this.loggerService.logError(this.ChatbotComponentError(error), `loadSessionsForDataset-${datasetName}-page-${page}`);
      }
    });
  }

  /**
   * Handle tab selection to load sessions for specific module
   */
  onTabSelected(event: TabSelectionEvent): void {
    
    // Update selected tab (keep 'All' as is, convert others to lowercase)
    this.selectedTab = event.tabName === 'All' ? 'All' : event.tabName.toLowerCase();
    
    // Update ConversationHistoryCount based on new tab selection
    this.ConversationHistoryCount = this.getConversationHistoryCount();
    
    // If "All" tab is selected, we may want to reload all sessions
    // For now, we'll only handle individual dataset tabs
    if (event.tabName === 'All') {
      return;
    }
    
    // Remove existing sessions for this specific module only (preserve other modules' sessions, New Topic, and currently selected session)
    this.chatSessionList = this.chatSessionList.filter((session: any) => 
      session.module_name?.toLowerCase() !== event.tabName.toLowerCase() || 
      session.chat_name === 'New Topic' ||
      session.is_selected === true
    );
    
    // Initialize pagination for this dataset if not exists
    if (!this.datasetPagination[event.tabName]) {
      this.datasetPagination[event.tabName] = {
        currentPage: 0,
        hasMoreData: true
      };
    }
    
    // Initialize loading state for this dataset if not exists
    if (this.datasetLoadingStates[event.tabName] === undefined) {
      this.datasetLoadingStates[event.tabName] = false;
    }
    
    // Reset pagination and load first page
    this.datasetPagination[event.tabName].currentPage = 0;
    this.datasetPagination[event.tabName].hasMoreData = true;
    
    // Load sessions for this specific dataset/module
    this.loadSessionsForDatasetPage(event.tabName, 1);
  }

  private getDaysFromFilter(filter: string): number {
    switch (filter) {
      case '7 Days': return 7;
      case '15 Days': return 15;
      case '30 Days': return 30;
      default: return 30;
    }
  }

  showWelcomeTour(): boolean {
    // Early return if tour is not enabled or already completed
    if (!this.firstTimeLoginDetails.tour_functionality_enabled || 
        this.firstTimeLoginDetails.tour_completion_status === 'completed') {
      return false;
    }
    // Tour is incomplete and enabled, check wizard dependency
    if (this.firstTimeLoginDetails.introduction_wizard_enabled) {
      // If wizard is enabled, it must be completed before showing tour
      return this.firstTimeLoginDetails.wizard_completion_status === 'completed';
    }
    // If wizard is not enabled, show tour directly
    return true;
  }

  showIntroSlides(): boolean {
    return this.firstTimeLoginDetails.introduction_wizard_enabled && 
           this.firstTimeLoginDetails.wizard_completion_status === 'incomplete';
  }

  // ==================== Helper Methods for File Upload ====================
  
  /**
   * Get all files currently being uploaded/processed
   * @returns Array of FileUploadTracker objects
   */
  getUploadingFiles(): FileUploadTracker[] {
    return Array.from(this.fileUploadState.activeUploads.values());
  }
  
  /**
   * Get file names of files being uploaded (for template compatibility)
   * @returns Array of file names
   */
  getUploadingFileNames(): string[] {
    return Array.from(this.fileUploadState.activeUploads.values()).map(tracker => tracker.file.name);
  }
  
  /**
   * Get upload status for a specific file by docId
   * @param docId Document ID
   * @returns Upload status or undefined
   */
  getUploadStatus(docId: string): 'validating' | 'validating-pages' | 'uploading' | 'success' | 'error' | undefined {
    return this.fileUploadState.activeUploads.get(docId)?.status;
  }
  
  /**
   * Find tracker by file reference
   * @param file File object to search for
   * @returns Object containing docId and tracker, or null if not found
   */
  private getTrackerByFile(file: File): { docId: string; tracker: FileUploadTracker } | null {
    for (const [docId, tracker] of this.fileUploadState.activeUploads.entries()) {
      if (tracker.file === file) {
        return { docId, tracker };
      }
    }
    return null;
  }
  
  /**
   * Preview file document in the file preview panel
   * @param file File metadata object with name, size, type, and optional documentId
   */
  previewFile(file: {name: string, size: number, type: string, documentId?: number, presignedUrl?: string, file?: File}): void {
    
    if (!this.isFileUploadEnabled) {
      return;
    }
    try {
      
      // If no documentId, try to find it from the map
      let documentId = file.documentId;
      if (!documentId) {
        const fileKey = `${file.name}_${file.size}`;
        documentId = this.fileToDocumentIdMap.get(fileKey);
      }
      
      if (!documentId && !file.presignedUrl && !file.file) {
        this.loggerService.logError('No documentId, presignedUrl, or file object available for preview', 'previewFile');
        alert(`Cannot preview "${file.name}" - file source not available`);
        return;
      }
      
      // Close other panels
      this.closeSourcePanel();
      this.DisableChatHistory();
      
      // Prepare preview request
      this.currentFilePreviewRequest = {
        documentId: documentId,
        presignedUrl: file.presignedUrl,
        file: file.file,
        fileName: file.name,
        fileType: file.type
      };
      
      // Show file preview panel
      this.isFilePreviewVisible = true;
      this.cdr.detectChanges();
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'previewFile');
      alert(`Failed to open preview for "${file.name}"`);
    }
  }
  
  /**
   * Close file preview panel
   */
  closeFilePreviewPanel(): void {
    if (!this.isFileUploadEnabled) {
      return;
    }
    try {
      this.isFilePreviewVisible = false;
      this.currentFilePreviewRequest = null;
      this.cdr.detectChanges();
    } catch (error: any) {
      this.loggerService.logError(this.ChatbotComponentError(error), 'closeFilePreviewPanel');
    }
  }
  
}
